var _defineProperty = require("/builds/client-projects/fert-demolition-motos-website/application/node_modules/@babel/runtime/helpers/defineProperty.js").default;

var _regeneratorRuntime = require("/builds/client-projects/fert-demolition-motos-website/application/node_modules/@babel/runtime/regenerator/index.js");

var _asyncToGenerator = require("/builds/client-projects/fert-demolition-motos-website/application/node_modules/@babel/runtime/helpers/asyncToGenerator.js").default;

var _slicedToArray = require("/builds/client-projects/fert-demolition-motos-website/application/node_modules/@babel/runtime/helpers/slicedToArray.js").default;

var _objectSpread = require("/builds/client-projects/fert-demolition-motos-website/application/node_modules/@babel/runtime/helpers/objectSpread2.js").default;

var _objectWithoutProperties = require("/builds/client-projects/fert-demolition-motos-website/application/node_modules/@babel/runtime/helpers/objectWithoutProperties.js").default;

var _excluded = ["icon", "size"];
!function webpackUniversalModuleDefinition(e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define([], t) : "object" == typeof exports ? exports["@wordpress/reusable-blocks"] = t() : (e.wp = e.wp || {}, e.wp.reusableBlocks = t());
}(self, function () {
  return function () {
    var e = {
      424: function _(e) {
        e.exports = function _interopRequireDefault(e) {
          return e && e.__esModule ? e : {
            default: e
          };
        }, e.exports.__esModule = !0, e.exports.default = e.exports;
      },
      614: function _(e, t, l) {
        "use strict";

        l.r(t), l.d(t, {
          Icon: function Icon() {
            return h;
          },
          addCard: function addCard() {
            return r;
          },
          addSubmenu: function addSubmenu() {
            return n;
          },
          alignCenter: function alignCenter() {
            return o;
          },
          alignJustify: function alignJustify() {
            return i;
          },
          alignJustifyAlt: function alignJustifyAlt() {
            return z;
          },
          alignLeft: function alignLeft() {
            return g;
          },
          alignNone: function alignNone() {
            return H;
          },
          alignRight: function alignRight() {
            return p;
          },
          archive: function archive() {
            return u;
          },
          archiveTitle: function archiveTitle() {
            return S;
          },
          arrowDown: function arrowDown() {
            return P;
          },
          arrowLeft: function arrowLeft() {
            return C;
          },
          arrowRight: function arrowRight() {
            return b;
          },
          arrowUp: function arrowUp() {
            return R;
          },
          aspectRatio: function aspectRatio() {
            return I;
          },
          atSymbol: function atSymbol() {
            return y;
          },
          audio: function audio() {
            return q;
          },
          backup: function backup() {
            return j;
          },
          blockDefault: function blockDefault() {
            return D;
          },
          blockTable: function blockTable() {
            return W;
          },
          box: function box() {
            return U;
          },
          brush: function brush() {
            return K;
          },
          bug: function bug() {
            return X;
          },
          button: function button() {
            return $;
          },
          buttons: function buttons() {
            return te;
          },
          calendar: function calendar() {
            return ce;
          },
          cancelCircleFilled: function cancelCircleFilled() {
            return ve;
          },
          capturePhoto: function capturePhoto() {
            return re;
          },
          captureVideo: function captureVideo() {
            return ne;
          },
          category: function category() {
            return oe;
          },
          chartBar: function chartBar() {
            return ie;
          },
          check: function check() {
            return ze;
          },
          chevronDown: function chevronDown() {
            return ge;
          },
          chevronLeft: function chevronLeft() {
            return He;
          },
          chevronRight: function chevronRight() {
            return pe;
          },
          chevronRightSmall: function chevronRightSmall() {
            return ue;
          },
          chevronUp: function chevronUp() {
            return Se;
          },
          classic: function classic() {
            return Pe;
          },
          close: function close() {
            return Ce;
          },
          closeSmall: function closeSmall() {
            return be;
          },
          cloud: function cloud() {
            return ye;
          },
          cloudUpload: function cloudUpload() {
            return Re;
          },
          code: function code() {
            return Ie;
          },
          cog: function cog() {
            return qe;
          },
          cogAlt: function cogAlt() {
            return je;
          },
          color: function color() {
            return De;
          },
          column: function column() {
            return We;
          },
          columns: function columns() {
            return Ue;
          },
          comment: function comment() {
            return Ke;
          },
          commentAuthorAvatar: function commentAuthorAvatar() {
            return Xe;
          },
          commentAuthorName: function commentAuthorName() {
            return $e;
          },
          commentContent: function commentContent() {
            return tt;
          },
          commentReplyLink: function commentReplyLink() {
            return ct;
          },
          cover: function cover() {
            return vt;
          },
          create: function create() {
            return rt;
          },
          crop: function crop() {
            return nt;
          },
          currencyDollar: function currencyDollar() {
            return ot;
          },
          currencyEuro: function currencyEuro() {
            return it;
          },
          currencyPound: function currencyPound() {
            return zt;
          },
          customLink: function customLink() {
            return ah;
          },
          customPostType: function customPostType() {
            return gt;
          },
          desktop: function desktop() {
            return Ht;
          },
          download: function download() {
            return ut;
          },
          dragHandle: function dragHandle() {
            return pt;
          },
          edit: function edit() {
            return Lt;
          },
          external: function external() {
            return Gt;
          },
          file: function file() {
            return ft;
          },
          flipHorizontal: function flipHorizontal() {
            return _t;
          },
          flipVertical: function flipVertical() {
            return kt;
          },
          footer: function footer() {
            return fv;
          },
          formatBold: function formatBold() {
            return Zt;
          },
          formatCapitalize: function formatCapitalize() {
            return At;
          },
          formatIndent: function formatIndent() {
            return Ot;
          },
          formatIndentRTL: function formatIndentRTL() {
            return Tt;
          },
          formatItalic: function formatItalic() {
            return Ft;
          },
          formatListBullets: function formatListBullets() {
            return Nt;
          },
          formatListBulletsRTL: function formatListBulletsRTL() {
            return Jt;
          },
          formatListNumbered: function formatListNumbered() {
            return Qt;
          },
          formatListNumberedRTL: function formatListNumberedRTL() {
            return Yt;
          },
          formatLowercase: function formatLowercase() {
            return ll;
          },
          formatLtr: function formatLtr() {
            return el;
          },
          formatOutdent: function formatOutdent() {
            return hl;
          },
          formatOutdentRTL: function formatOutdentRTL() {
            return al;
          },
          formatRtl: function formatRtl() {
            return wl;
          },
          formatStrikethrough: function formatStrikethrough() {
            return ml;
          },
          formatUnderline: function formatUnderline() {
            return sl;
          },
          formatUppercase: function formatUppercase() {
            return Vl;
          },
          fullscreen: function fullscreen() {
            return dl;
          },
          gallery: function gallery() {
            return El;
          },
          globe: function globe() {
            return xl;
          },
          grid: function grid() {
            return Ml;
          },
          group: function group() {
            return Bl;
          },
          handle: function handle() {
            return Ll;
          },
          header: function header() {
            return bv;
          },
          heading: function heading() {
            return Gl;
          },
          help: function help() {
            return fl;
          },
          helpFilled: function helpFilled() {
            return _l;
          },
          home: function home() {
            return Al;
          },
          html: function html() {
            return Ol;
          },
          image: function image() {
            return Tl;
          },
          inbox: function inbox() {
            return kl;
          },
          info: function info() {
            return Fl;
          },
          insertAfter: function insertAfter() {
            return Nl;
          },
          insertBefore: function insertBefore() {
            return Jl;
          },
          institution: function institution() {
            return Zl;
          },
          justifyCenter: function justifyCenter() {
            return Yl;
          },
          justifyLeft: function justifyLeft() {
            return Ql;
          },
          justifyRight: function justifyRight() {
            return ec;
          },
          justifySpaceBetween: function justifySpaceBetween() {
            return lc;
          },
          key: function key() {
            return hc;
          },
          keyboardClose: function keyboardClose() {
            return ac;
          },
          keyboardReturn: function keyboardReturn() {
            return wc;
          },
          layout: function layout() {
            return mc;
          },
          lifesaver: function lifesaver() {
            return sc;
          },
          lineDashed: function lineDashed() {
            return Vc;
          },
          lineDotted: function lineDotted() {
            return dc;
          },
          lineSolid: function lineSolid() {
            return Ec;
          },
          link: function link() {
            return xc;
          },
          linkOff: function linkOff() {
            return Mc;
          },
          list: function list() {
            return Bc;
          },
          listView: function listView() {
            return Lc;
          },
          lock: function lock() {
            return Gc;
          },
          login: function login() {
            return fc;
          },
          loop: function loop() {
            return _c;
          },
          mapMarker: function mapMarker() {
            return kc;
          },
          media: function media() {
            return Zc;
          },
          mediaAndText: function mediaAndText() {
            return Ac;
          },
          megaphone: function megaphone() {
            return Oc;
          },
          menu: function menu() {
            return Tc;
          },
          mobile: function mobile() {
            return Fc;
          },
          more: function more() {
            return Nc;
          },
          moreHorizontal: function moreHorizontal() {
            return Jc;
          },
          moreHorizontalMobile: function moreHorizontalMobile() {
            return Qc;
          },
          moreVertical: function moreVertical() {
            return Yc;
          },
          moveTo: function moveTo() {
            return eh;
          },
          navigation: function navigation() {
            return lh;
          },
          next: function next() {
            return Rh;
          },
          overlayText: function overlayText() {
            return hh;
          },
          page: function page() {
            return rh;
          },
          pageBreak: function pageBreak() {
            return vh;
          },
          pages: function pages() {
            return wh;
          },
          paragraph: function paragraph() {
            return nh;
          },
          payment: function payment() {
            return mh;
          },
          pencil: function pencil() {
            return St;
          },
          people: function people() {
            return zh;
          },
          percent: function percent() {
            return oh;
          },
          pin: function pin() {
            return dh;
          },
          plugins: function plugins() {
            return gh;
          },
          plus: function plus() {
            return xh;
          },
          plusCircle: function plusCircle() {
            return Hh;
          },
          plusCircleFilled: function plusCircleFilled() {
            return Eh;
          },
          positionCenter: function positionCenter() {
            return sh;
          },
          positionLeft: function positionLeft() {
            return ih;
          },
          positionRight: function positionRight() {
            return Vh;
          },
          postAuthor: function postAuthor() {
            return ph;
          },
          postCategories: function postCategories() {
            return Mh;
          },
          postComments: function postComments() {
            return Bh;
          },
          postCommentsCount: function postCommentsCount() {
            return Sh;
          },
          postCommentsForm: function postCommentsForm() {
            return Lh;
          },
          postContent: function postContent() {
            return uh;
          },
          postDate: function postDate() {
            return Ph;
          },
          postExcerpt: function postExcerpt() {
            return Gh;
          },
          postFeaturedImage: function postFeaturedImage() {
            return Ch;
          },
          postList: function postList() {
            return fh;
          },
          postTitle: function postTitle() {
            return bh;
          },
          preformatted: function preformatted() {
            return kh;
          },
          previous: function previous() {
            return _h;
          },
          pullLeft: function pullLeft() {
            return yh;
          },
          pullRight: function pullRight() {
            return Zh;
          },
          pullquote: function pullquote() {
            return Ih;
          },
          queryPagination: function queryPagination() {
            return Ah;
          },
          queryPaginationNext: function queryPaginationNext() {
            return qh;
          },
          queryPaginationNumbers: function queryPaginationNumbers() {
            return Oh;
          },
          queryPaginationPrevious: function queryPaginationPrevious() {
            return jh;
          },
          quote: function quote() {
            return Th;
          },
          receipt: function receipt() {
            return Dh;
          },
          redo: function redo() {
            return Fh;
          },
          removeBug: function removeBug() {
            return Wh;
          },
          replace: function replace() {
            return Nh;
          },
          reset: function reset() {
            return Uh;
          },
          resizeCornerNE: function resizeCornerNE() {
            return Jh;
          },
          reusableBlock: function reusableBlock() {
            return Kh;
          },
          rotateLeft: function rotateLeft() {
            return Xh;
          },
          rotateRight: function rotateRight() {
            return Yh;
          },
          rss: function rss() {
            return $h;
          },
          search: function search() {
            return ev;
          },
          separator: function separator() {
            return tv;
          },
          settings: function settings() {
            return lv;
          },
          share: function share() {
            return cv;
          },
          shield: function shield() {
            return hv;
          },
          shipping: function shipping() {
            return zv;
          },
          shortcode: function shortcode() {
            return vv;
          },
          sidebar: function sidebar() {
            return _v;
          },
          siteLogo: function siteLogo() {
            return av;
          },
          sparkles: function sparkles() {
            return rv;
          },
          stack: function stack() {
            return wv;
          },
          starEmpty: function starEmpty() {
            return nv;
          },
          starFilled: function starFilled() {
            return mv;
          },
          starHalf: function starHalf() {
            return ov;
          },
          store: function store() {
            return sv;
          },
          stretchFullWidth: function stretchFullWidth() {
            return iv;
          },
          stretchWide: function stretchWide() {
            return dv;
          },
          styles: function styles() {
            return Vv;
          },
          subscript: function subscript() {
            return gv;
          },
          superscript: function superscript() {
            return Ev;
          },
          swatch: function swatch() {
            return Hv;
          },
          symbol: function symbol() {
            return Qh;
          },
          symbolFilled: function symbolFilled() {
            return Gv;
          },
          table: function table() {
            return Lv;
          },
          tableColumnAfter: function tableColumnAfter() {
            return xv;
          },
          tableColumnBefore: function tableColumnBefore() {
            return pv;
          },
          tableColumnDelete: function tableColumnDelete() {
            return Mv;
          },
          tableRowAfter: function tableRowAfter() {
            return uv;
          },
          tableRowBefore: function tableRowBefore() {
            return Bv;
          },
          tableRowDelete: function tableRowDelete() {
            return Sv;
          },
          tablet: function tablet() {
            return kv;
          },
          tag: function tag() {
            return Pv;
          },
          termDescription: function termDescription() {
            return Cv;
          },
          textColor: function textColor() {
            return Rv;
          },
          title: function title() {
            return yv;
          },
          tool: function tool() {
            return Zv;
          },
          trash: function trash() {
            return Iv;
          },
          trashFilled: function trashFilled() {
            return Av;
          },
          trendingDown: function trendingDown() {
            return qv;
          },
          trendingUp: function trendingUp() {
            return Ov;
          },
          typography: function typography() {
            return jv;
          },
          undo: function undo() {
            return Tv;
          },
          ungroup: function ungroup() {
            return Dv;
          },
          update: function update() {
            return Fv;
          },
          upload: function upload() {
            return Wv;
          },
          verse: function verse() {
            return Nv;
          },
          video: function video() {
            return Uv;
          },
          warning: function warning() {
            return Jv;
          },
          widget: function widget() {
            return Kv;
          },
          wordpress: function wordpress() {
            return Qv;
          }
        });
        var c = l(753);

        var h = function Icon(e) {
          var t = e.icon,
              _e$size = e.size,
              l = _e$size === void 0 ? 24 : _e$size,
              h = _objectWithoutProperties(e, _excluded);

          return (0, c.cloneElement)(t, _objectSpread({
            width: l,
            height: l
          }, h));
        },
            v = require("@wordpress/primitives"),
            a = (0, c.createElement)(v.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, c.createElement)(v.Path, {
          d: "M18.5 5.5V8H20V5.5h2.5V4H20V1.5h-1.5V4H16v1.5h2.5zM12 4H6a2 2 0 00-2 2v12a2 2 0 002 2h12a2 2 0 002-2v-6h-1.5v6a.5.5 0 01-.5.5H6a.5.5 0 01-.5-.5V6a.5.5 0 01.5-.5h6V4z"
        })),
            r = a,
            w = (0, c.createElement)(v.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, c.createElement)(v.Path, {
          d: "M2 12c0 3.6 2.4 5.5 6 5.5h.5V19l3-2.5-3-2.5v2H8c-2.5 0-4.5-1.5-4.5-4s2-4.5 4.5-4.5h3.5V6H8c-3.6 0-6 2.4-6 6zm19.5-1h-8v1.5h8V11zm0 5h-8v1.5h8V16zm0-10h-8v1.5h8V6z"
        })),
            n = w,
            m = (0, c.createElement)(v.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, c.createElement)(v.Path, {
          d: "M16.4 4.2H7.6v1.5h8.9V4.2zM4 11.2v1.5h16v-1.5H4zm3.6 8.6h8.9v-1.5H7.6v1.5z"
        })),
            o = m,
            s = (0, c.createElement)(v.SVG, {
          xmlns: "https://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, c.createElement)(v.Path, {
          d: "M4 12.8h16v-1.5H4v1.5zm0 7h12.4v-1.5H4v1.5zM4 4.3v1.5h16V4.3H4z"
        })),
            i = s,
            V = (0, c.createElement)(v.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, c.createElement)(v.Path, {
          clipRule: "evenodd",
          fillRule: "evenodd",
          d: "M4 5h16v2H4V5zm0 4v2h16V9H4zm0 4h16v2H4v-2zm16 6H4v-2h16v2z"
        })),
            z = V,
            d = (0, c.createElement)(v.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, c.createElement)(v.Path, {
          d: "M4 19.8h8.9v-1.5H4v1.5zm8.9-15.6H4v1.5h8.9V4.2zm-8.9 7v1.5h16v-1.5H4z"
        })),
            g = d,
            E = (0, c.createElement)(v.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, c.createElement)(v.Path, {
          d: "M5 15h14V9H5v6zm0 4.8h14v-1.5H5v1.5zM5 4.2v1.5h14V4.2H5z"
        })),
            H = E,
            x = (0, c.createElement)(v.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, c.createElement)(v.Path, {
          d: "M11.1 19.8H20v-1.5h-8.9v1.5zm0-15.6v1.5H20V4.2h-8.9zM4 12.8h16v-1.5H4v1.5z"
        })),
            p = x,
            M = (0, c.createElement)(v.SVG, {
          viewBox: "0 0 24 24",
          xmlns: "http://www.w3.org/2000/svg"
        }, (0, c.createElement)(v.Path, {
          d: "M19 6.2h-5.9l-.6-1.1c-.3-.7-1-1.1-1.8-1.1H5c-1.1 0-2 .9-2 2v11.8c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V8.2c0-1.1-.9-2-2-2zm.5 11.6c0 .3-.2.5-.5.5H5c-.3 0-.5-.2-.5-.5V6c0-.3.2-.5.5-.5h5.8c.2 0 .4.1.4.3l1 2H19c.3 0 .5.2.5.5v9.5zM8 12.8h8v-1.5H8v1.5zm0 3h8v-1.5H8v1.5z"
        })),
            u = M,
            B = (0, c.createElement)(v.SVG, {
          viewBox: "0 0 24 24",
          xmlns: "http://www.w3.org/2000/svg"
        }, (0, c.createElement)(v.Path, {
          stroke: "#1E1E1E",
          strokeWidth: "1.5",
          d: "M4 19.25h9M4 15.25h16"
        }), (0, c.createElement)(v.Path, {
          d: "M8.994 10.103H6.08L5.417 12H4l2.846-8h1.383l2.845 8H9.657l-.663-1.897zm-.457-1.28l-.994-2.857-1.006 2.857h2z",
          fill: "#1E1E1E"
        })),
            S = B,
            L = (0, c.createElement)(v.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, c.createElement)(v.Path, {
          d: "M16.2 13.2l-4 4V4h-1.5v13.3l-4.5-4.1-1 1.1 6.2 5.8 5.8-5.8-1-1.1z"
        })),
            P = L,
            G = (0, c.createElement)(v.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, c.createElement)(v.Path, {
          d: "M20 10.8H6.7l4.1-4.5-1.1-1.1-5.8 6.3 5.8 5.8 1.1-1.1-4-3.9H20z"
        })),
            C = G,
            f = (0, c.createElement)(v.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, c.createElement)(v.Path, {
          d: "M14.3 6.7l-1.1 1.1 4 4H4v1.5h13.3l-4.1 4.4 1.1 1.1 5.8-6.3z"
        })),
            b = f,
            _ = (0, c.createElement)(v.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, c.createElement)(v.Path, {
          d: "M12.5 3.9L6.7 9.7l1.1 1.1 4-4V20h1.4V6.7l4.5 4.1 1.1-1.1z"
        })),
            R = _,
            k = (0, c.createElement)(v.SVG, {
          width: "24",
          height: "24",
          viewBox: "0 0 24 24",
          xmlns: "http://www.w3.org/2000/svg"
        }, (0, c.createElement)(v.Path, {
          d: "M12.5939 21C14.1472 21 16.1269 20.5701 17.0711 20.1975L16.6447 18.879C16.0964 19.051 14.3299 19.6242 12.6548 19.6242C7.4467 19.6242 4.67513 16.8726 4.67513 12C4.67513 7.21338 7.50762 4.34713 12.2893 4.34713C17.132 4.34713 19.4162 7.55732 19.4162 10.7675C19.4162 14.035 19.0508 15.4968 17.4975 15.4968C16.5838 15.4968 16.0964 14.7803 16.0964 13.9777V7.5H14.4822V8.30255H14.3909C14.1777 7.67198 12.9898 7.12739 11.467 7.2707C9.18274 7.5 7.4467 9.27707 7.4467 11.8567C7.4467 14.5796 8.81726 16.672 11.467 16.758C13.203 16.8153 14.1168 16.0127 14.4822 15.1815H14.5736C14.7563 16.414 16.401 16.8439 17.467 16.8439C20.6954 16.8439 21 13.5764 21 10.7962C21 6.86943 18.0761 3 12.3807 3C6.50254 3 3 6.3535 3 11.9427C3 17.7325 6.38071 21 12.5939 21ZM11.7107 15.2962C9.73096 15.2962 9.03046 13.6051 9.03046 11.7707C9.03046 10.1083 10.0355 8.67516 11.7716 8.67516C13.599 8.67516 14.5736 9.36306 14.5736 11.7707C14.5736 14.1497 13.7513 15.2962 11.7107 15.2962Z"
        })),
            y = k,
            Z = (0, c.createElement)(v.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, c.createElement)(v.Path, {
          d: "M18.5 5.5h-13c-1.1 0-2 .9-2 2v9c0 1.1.9 2 2 2h13c1.1 0 2-.9 2-2v-9c0-1.1-.9-2-2-2zm.5 11c0 .3-.2.5-.5.5h-13c-.3 0-.5-.2-.5-.5v-9c0-.3.2-.5.5-.5h13c.3 0 .5.2.5.5v9zM6.5 12H8v-2h2V8.5H6.5V12zm9.5 2h-2v1.5h3.5V12H16v2z"
        })),
            I = Z,
            A = (0, c.createElement)(v.SVG, {
          viewBox: "0 0 24 24",
          xmlns: "http://www.w3.org/2000/svg"
        }, (0, c.createElement)(v.Path, {
          d: "M17.7 4.3c-1.2 0-2.8 0-3.8 1-.6.6-.9 1.5-.9 2.6V14c-.6-.6-1.5-1-2.5-1C8.6 13 7 14.6 7 16.5S8.6 20 10.5 20c1.5 0 2.8-1 3.3-2.3.5-.8.7-1.8.7-2.5V7.9c0-.7.2-1.2.5-1.6.6-.6 1.8-.6 2.8-.6h.3V4.3h-.4z"
        })),
            q = A,
            O = (0, c.createElement)(v.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, c.createElement)(v.Path, {
          d: "M5.5 12h1.75l-2.5 3-2.5-3H4a8 8 0 113.134 6.35l.907-1.194A6.5 6.5 0 105.5 12zm9.53 1.97l-2.28-2.28V8.5a.75.75 0 00-1.5 0V12a.747.747 0 00.218.529l1.282-.84-1.28.842 2.5 2.5a.75.75 0 101.06-1.061z"
        })),
            j = O,
            T = (0, c.createElement)(v.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, c.createElement)(v.Path, {
          d: "M19 8h-1V6h-5v2h-2V6H6v2H5c-1.1 0-2 .9-2 2v8c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-8c0-1.1-.9-2-2-2zm.5 10c0 .3-.2.5-.5.5H5c-.3 0-.5-.2-.5-.5v-8c0-.3.2-.5.5-.5h14c.3 0 .5.2.5.5v8z"
        })),
            D = T,
            F = (0, c.createElement)(v.SVG, {
          viewBox: "0 0 24 24",
          xmlns: "http://www.w3.org/2000/svg"
        }, (0, c.createElement)(v.Path, {
          d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM5 4.5h14c.3 0 .5.2.5.5v3.5h-15V5c0-.3.2-.5.5-.5zm8 5.5h6.5v3.5H13V10zm-1.5 3.5h-7V10h7v3.5zm-7 5.5v-4h7v4.5H5c-.3 0-.5-.2-.5-.5zm14.5.5h-6V15h6.5v4c0 .3-.2.5-.5.5z"
        })),
            W = F,
            N = (0, c.createElement)(v.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, c.createElement)(v.Path, {
          fillRule: "evenodd",
          d: "M5 5.5h14a.5.5 0 01.5.5v1.5a.5.5 0 01-.5.5H5a.5.5 0 01-.5-.5V6a.5.5 0 01.5-.5zM4 9.232A2 2 0 013 7.5V6a2 2 0 012-2h14a2 2 0 012 2v1.5a2 2 0 01-1 1.732V18a2 2 0 01-2 2H6a2 2 0 01-2-2V9.232zm1.5.268V18a.5.5 0 00.5.5h12a.5.5 0 00.5-.5V9.5h-13z",
          clipRule: "evenodd"
        })),
            U = N,
            J = (0, c.createElement)(v.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, c.createElement)(v.Path, {
          d: "M4 20h8v-1.5H4V20zM18.9 3.5c-.6-.6-1.5-.6-2.1 0l-7.2 7.2c-.4-.1-.7 0-1.1.1-.5.2-1.5.7-1.9 2.2-.4 1.7-.8 2.2-1.1 2.7-.1.1-.2.3-.3.4l-.6 1.1H6c2 0 3.4-.4 4.7-1.4.8-.6 1.2-1.4 1.3-2.3 0-.3 0-.5-.1-.7L19 5.7c.5-.6.5-1.6-.1-2.2zM9.7 14.7c-.7.5-1.5.8-2.4 1 .2-.5.5-1.2.8-2.3.2-.6.4-1 .8-1.1.5-.1 1 .1 1.3.3.2.2.3.5.2.8 0 .3-.1.9-.7 1.3z"
        })),
            K = J,
            Q = (0, c.createElement)(v.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, c.createElement)(v.Path, {
          d: "M6.13 5.5l1.926 1.927A4.975 4.975 0 007.025 10H5v1.5h2V13H5v1.5h2.1a5.002 5.002 0 009.8 0H19V13h-2v-1.5h2V10h-2.025a4.979 4.979 0 00-1.167-2.74l1.76-1.76-1.061-1.06-1.834 1.834A4.977 4.977 0 0012 5.5c-1.062 0-2.046.33-2.855.895L7.19 4.44 6.13 5.5zm2.37 5v3a3.5 3.5 0 107 0v-3a3.5 3.5 0 10-7 0z",
          fillRule: "evenodd",
          clipRule: "evenodd"
        })),
            X = Q,
            Y = (0, c.createElement)(v.SVG, {
          viewBox: "0 0 24 24",
          xmlns: "http://www.w3.org/2000/svg"
        }, (0, c.createElement)(v.Path, {
          d: "M19 6.5H5c-1.1 0-2 .9-2 2v7c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-7c0-1.1-.9-2-2-2zm.5 9c0 .3-.2.5-.5.5H5c-.3 0-.5-.2-.5-.5v-7c0-.3.2-.5.5-.5h14c.3 0 .5.2.5.5v7zM8 12.8h8v-1.5H8v1.5z"
        })),
            $ = Y,
            ee = (0, c.createElement)(v.SVG, {
          viewBox: "0 0 24 24",
          xmlns: "http://www.w3.org/2000/svg"
        }, (0, c.createElement)(v.Path, {
          d: "M17 3H7c-1.1 0-2 .9-2 2v4c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm.5 6c0 .3-.2.5-.5.5H7c-.3 0-.5-.2-.5-.5V5c0-.3.2-.5.5-.5h10c.3 0 .5.2.5.5v4zm-8-1.2h5V6.2h-5v1.6zM17 13H7c-1.1 0-2 .9-2 2v4c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2v-4c0-1.1-.9-2-2-2zm.5 6c0 .3-.2.5-.5.5H7c-.3 0-.5-.2-.5-.5v-4c0-.3.2-.5.5-.5h10c.3 0 .5.2.5.5v4zm-8-1.2h5v-1.5h-5v1.5z"
        })),
            te = ee,
            le = (0, c.createElement)(v.SVG, {
          viewBox: "0 0 24 24",
          xmlns: "http://www.w3.org/2000/svg"
        }, (0, c.createElement)(v.Path, {
          d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm.5 16c0 .3-.2.5-.5.5H5c-.3 0-.5-.2-.5-.5V7h15v12zM9 10H7v2h2v-2zm0 4H7v2h2v-2zm4-4h-2v2h2v-2zm4 0h-2v2h2v-2zm-4 4h-2v2h2v-2zm4 0h-2v2h2v-2z"
        })),
            ce = le,
            he = (0, c.createElement)(v.SVG, {
          viewBox: "0 0 24 24",
          xmlns: "http://www.w3.org/2000/svg"
        }, (0, c.createElement)(v.Path, {
          d: "M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21ZM15.5303 8.46967C15.8232 8.76256 15.8232 9.23744 15.5303 9.53033L13.0607 12L15.5303 14.4697C15.8232 14.7626 15.8232 15.2374 15.5303 15.5303C15.2374 15.8232 14.7626 15.8232 14.4697 15.5303L12 13.0607L9.53033 15.5303C9.23744 15.8232 8.76256 15.8232 8.46967 15.5303C8.17678 15.2374 8.17678 14.7626 8.46967 14.4697L10.9393 12L8.46967 9.53033C8.17678 9.23744 8.17678 8.76256 8.46967 8.46967C8.76256 8.17678 9.23744 8.17678 9.53033 8.46967L12 10.9393L14.4697 8.46967C14.7626 8.17678 15.2374 8.17678 15.5303 8.46967Z"
        })),
            ve = he,
            ae = (0, c.createElement)(v.SVG, {
          viewBox: "0 0 24 24",
          xmlns: "http://www.w3.org/2000/svg"
        }, (0, c.createElement)(v.Path, {
          d: "M12 9.2c-2.2 0-3.9 1.8-3.9 4s1.8 4 3.9 4 4-1.8 4-4-1.8-4-4-4zm0 6.5c-1.4 0-2.4-1.1-2.4-2.5s1.1-2.5 2.4-2.5 2.5 1.1 2.5 2.5-1.1 2.5-2.5 2.5zM20.2 8c-.1 0-.3 0-.5-.1l-2.5-.8c-.4-.1-.8-.4-1.1-.8l-1-1.5c-.4-.5-1-.9-1.7-.9h-2.9c-.6.1-1.2.4-1.6 1l-1 1.5c-.3.3-.6.6-1.1.7l-2.5.8c-.2.1-.4.1-.6.1-1 .2-1.7.9-1.7 1.9v8.3c0 1 .9 1.9 2 1.9h16c1.1 0 2-.8 2-1.9V9.9c0-1-.7-1.7-1.8-1.9zm.3 10.1c0 .2-.2.4-.5.4H4c-.3 0-.5-.2-.5-.4V9.9c0-.1.2-.3.5-.4.2 0 .5-.1.8-.2l2.5-.8c.7-.2 1.4-.6 1.8-1.3l1-1.5c.1-.1.2-.2.4-.2h2.9c.2 0 .3.1.4.2l1 1.5c.4.7 1.1 1.1 1.9 1.4l2.5.8c.3.1.6.1.8.2.3 0 .4.2.4.4v8.1z"
        })),
            re = ae,
            we = (0, c.createElement)(v.SVG, {
          viewBox: "0 0 24 24",
          xmlns: "http://www.w3.org/2000/svg"
        }, (0, c.createElement)(v.Path, {
          d: "M14 5H4c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm.5 12c0 .3-.2.5-.5.5H4c-.3 0-.5-.2-.5-.5V7c0-.3.2-.5.5-.5h10c.3 0 .5.2.5.5v10zm2.5-7v4l5 3V7l-5 3zm3.5 4.4l-2-1.2v-2.3l2-1.2v4.7z"
        })),
            ne = we,
            me = (0, c.createElement)(v.SVG, {
          viewBox: "0 0 24 24",
          xmlns: "http://www.w3.org/2000/svg"
        }, (0, c.createElement)(v.Path, {
          d: "M6 5.5h3a.5.5 0 01.5.5v3a.5.5 0 01-.5.5H6a.5.5 0 01-.5-.5V6a.5.5 0 01.5-.5zM4 6a2 2 0 012-2h3a2 2 0 012 2v3a2 2 0 01-2 2H6a2 2 0 01-2-2V6zm11-.5h3a.5.5 0 01.5.5v3a.5.5 0 01-.5.5h-3a.5.5 0 01-.5-.5V6a.5.5 0 01.5-.5zM13 6a2 2 0 012-2h3a2 2 0 012 2v3a2 2 0 01-2 2h-3a2 2 0 01-2-2V6zm5 8.5h-3a.5.5 0 00-.5.5v3a.5.5 0 00.5.5h3a.5.5 0 00.5-.5v-3a.5.5 0 00-.5-.5zM15 13a2 2 0 00-2 2v3a2 2 0 002 2h3a2 2 0 002-2v-3a2 2 0 00-2-2h-3zm-9 1.5h3a.5.5 0 01.5.5v3a.5.5 0 01-.5.5H6a.5.5 0 01-.5-.5v-3a.5.5 0 01.5-.5zM4 15a2 2 0 012-2h3a2 2 0 012 2v3a2 2 0 01-2 2H6a2 2 0 01-2-2v-3z",
          fillRule: "evenodd",
          clipRule: "evenodd"
        })),
            oe = me,
            se = (0, c.createElement)(v.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, c.createElement)(v.Path, {
          fillRule: "evenodd",
          d: "M11.25 5h1.5v15h-1.5V5zM6 10h1.5v10H6V10zm12 4h-1.5v6H18v-6z",
          clipRule: "evenodd"
        })),
            ie = se,
            Ve = (0, c.createElement)(v.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, c.createElement)(v.Path, {
          d: "M16.7 7.1l-6.3 8.5-3.3-2.5-.9 1.2 4.5 3.4L17.9 8z"
        })),
            ze = Ve,
            de = (0, c.createElement)(v.SVG, {
          viewBox: "0 0 24 24",
          xmlns: "http://www.w3.org/2000/svg"
        }, (0, c.createElement)(v.Path, {
          d: "M17.5 11.6L12 16l-5.5-4.4.9-1.2L12 14l4.5-3.6 1 1.2z"
        })),
            ge = de,
            Ee = (0, c.createElement)(v.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, c.createElement)(v.Path, {
          d: "M14.6 7l-1.2-1L8 12l5.4 6 1.2-1-4.6-5z"
        })),
            He = Ee,
            xe = (0, c.createElement)(v.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, c.createElement)(v.Path, {
          d: "M10.6 6L9.4 7l4.6 5-4.6 5 1.2 1 5.4-6z"
        })),
            pe = xe,
            Me = (0, c.createElement)(v.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, c.createElement)(v.Path, {
          d: "M10.8622 8.04053L14.2805 12.0286L10.8622 16.0167L9.72327 15.0405L12.3049 12.0286L9.72327 9.01672L10.8622 8.04053Z"
        })),
            ue = Me,
            Be = (0, c.createElement)(v.SVG, {
          viewBox: "0 0 24 24",
          xmlns: "http://www.w3.org/2000/svg"
        }, (0, c.createElement)(v.Path, {
          d: "M6.5 12.4L12 8l5.5 4.4-.9 1.2L12 10l-4.5 3.6-1-1.2z"
        })),
            Se = Be,
            Le = (0, c.createElement)(v.SVG, {
          viewBox: "0 0 24 24",
          xmlns: "http://www.w3.org/2000/svg"
        }, (0, c.createElement)(v.Path, {
          d: "M20 6H4c-1.1 0-2 .9-2 2v9c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm.5 11c0 .3-.2.5-.5.5H4c-.3 0-.5-.2-.5-.5V8c0-.3.2-.5.5-.5h16c.3 0 .5.2.5.5v9zM10 10H8v2h2v-2zm-5 2h2v-2H5v2zm8-2h-2v2h2v-2zm-5 6h8v-2H8v2zm6-4h2v-2h-2v2zm3 0h2v-2h-2v2zm0 4h2v-2h-2v2zM5 16h2v-2H5v2z"
        })),
            Pe = Le,
            Ge = (0, c.createElement)(v.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, c.createElement)(v.Path, {
          d: "M13 11.8l6.1-6.3-1-1-6.1 6.2-6.1-6.2-1 1 6.1 6.3-6.5 6.7 1 1 6.5-6.6 6.5 6.6 1-1z"
        })),
            Ce = Ge,
            fe = (0, c.createElement)(v.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, c.createElement)(v.Path, {
          d: "M12 13.06l3.712 3.713 1.061-1.06L13.061 12l3.712-3.712-1.06-1.06L12 10.938 8.288 7.227l-1.061 1.06L10.939 12l-3.712 3.712 1.06 1.061L12 13.061z"
        })),
            be = fe,
            _e = (0, c.createElement)(v.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, c.createElement)(v.Path, {
          d: "M17.3 10.1c0-2.5-2.1-4.4-4.8-4.4-2.2 0-4.1 1.4-4.6 3.3h-.2C5.7 9 4 10.7 4 12.8c0 2.1 1.7 3.8 3.7 3.8h9c1.8 0 3.2-1.5 3.2-3.3.1-1.6-1.1-2.9-2.6-3.2zm-.5 5.1h-4v-2.4L14 14l1-1-3-3-3 3 1 1 1.2-1.2v2.4H7.7c-1.2 0-2.2-1.1-2.2-2.3s1-2.4 2.2-2.4H9l.3-1.1c.4-1.3 1.7-2.2 3.2-2.2 1.8 0 3.3 1.3 3.3 2.9v1.3l1.3.2c.8.1 1.4.9 1.4 1.8 0 1-.8 1.8-1.7 1.8z"
        })),
            Re = _e,
            ke = (0, c.createElement)(v.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, c.createElement)(v.Path, {
          d: "M17.3 10.1c0-2.5-2.1-4.4-4.8-4.4-2.2 0-4.1 1.4-4.6 3.3h-.2C5.7 9 4 10.7 4 12.8c0 2.1 1.7 3.8 3.7 3.8h9c1.8 0 3.2-1.5 3.2-3.3.1-1.6-1.1-2.9-2.6-3.2zm-.5 5.1h-9c-1.2 0-2.2-1.1-2.2-2.3s1-2.4 2.2-2.4h1.3l.3-1.1c.4-1.3 1.7-2.2 3.2-2.2 1.8 0 3.3 1.3 3.3 2.9v1.3l1.3.2c.8.1 1.4.9 1.4 1.8-.1 1-.9 1.8-1.8 1.8z"
        })),
            ye = ke,
            Ze = (0, c.createElement)(v.SVG, {
          viewBox: "0 0 24 24",
          xmlns: "http://www.w3.org/2000/svg"
        }, (0, c.createElement)(v.Path, {
          d: "M20.8 10.7l-4.3-4.3-1.1 1.1 4.3 4.3c.1.1.1.3 0 .4l-4.3 4.3 1.1 1.1 4.3-4.3c.7-.8.7-1.9 0-2.6zM4.2 11.8l4.3-4.3-1-1-4.3 4.3c-.7.7-.7 1.8 0 2.5l4.3 4.3 1.1-1.1-4.3-4.3c-.2-.1-.2-.3-.1-.4z"
        })),
            Ie = Ze,
            Ae = (0, c.createElement)(v.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, c.createElement)(v.Path, {
          fillRule: "evenodd",
          d: "M10.289 4.836A1 1 0 0111.275 4h1.306a1 1 0 01.987.836l.244 1.466c.787.26 1.503.679 2.108 1.218l1.393-.522a1 1 0 011.216.437l.653 1.13a1 1 0 01-.23 1.273l-1.148.944a6.025 6.025 0 010 2.435l1.149.946a1 1 0 01.23 1.272l-.653 1.13a1 1 0 01-1.216.437l-1.394-.522c-.605.54-1.32.958-2.108 1.218l-.244 1.466a1 1 0 01-.987.836h-1.306a1 1 0 01-.986-.836l-.244-1.466a5.995 5.995 0 01-2.108-1.218l-1.394.522a1 1 0 01-1.217-.436l-.653-1.131a1 1 0 01.23-1.272l1.149-.946a6.026 6.026 0 010-2.435l-1.148-.944a1 1 0 01-.23-1.272l.653-1.131a1 1 0 011.217-.437l1.393.522a5.994 5.994 0 012.108-1.218l.244-1.466zM14.929 12a3 3 0 11-6 0 3 3 0 016 0z",
          clipRule: "evenodd"
        })),
            qe = Ae,
            Oe = (0, c.createElement)(v.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, c.createElement)(v.Path, {
          clipRule: "evenodd",
          fillRule: "evenodd",
          d: "M19.867 12c0-.568-.059-1.122-.17-1.656L21.5 8.732l-1.967-3.464-2.283.786a7.813 7.813 0 00-2.813-1.657L13.967 2h-3.934l-.472 2.396a7.813 7.813 0 00-2.81 1.657l-2.284-.785L2.5 8.732l1.804 1.612a8.054 8.054 0 000 3.312L2.5 15.268l1.967 3.464 2.283-.786a7.813 7.813 0 002.813 1.657l.47 2.397h3.934l.472-2.396a7.83 7.83 0 002.81-1.657l2.284.786 1.967-3.464-1.804-1.613c.111-.535.171-1.09.171-1.657V12zM12 16c-2.173 0-3.934-1.79-3.934-4S9.826 8 12 8c2.173 0 3.934 1.79 3.934 4s-1.76 4-3.934 4z"
        })),
            je = Oe,
            Te = (0, c.createElement)(v.SVG, {
          viewBox: "0 0 24 24",
          xmlns: "http://www.w3.org/2000/svg"
        }, (0, c.createElement)(v.Path, {
          d: "M17.2 10.9c-.5-1-1.2-2.1-2.1-3.2-.6-.9-1.3-1.7-2.1-2.6L12 4l-1 1.1c-.6.9-1.3 1.7-2 2.6-.8 1.2-1.5 2.3-2 3.2-.6 1.2-1 2.2-1 3 0 3.4 2.7 6.1 6.1 6.1s6.1-2.7 6.1-6.1c0-.8-.3-1.8-1-3zm-5.1 7.6c-2.5 0-4.6-2.1-4.6-4.6 0-.3.1-1 .8-2.3.5-.9 1.1-1.9 2-3.1.7-.9 1.3-1.7 1.8-2.3.7.8 1.3 1.6 1.8 2.3.8 1.1 1.5 2.2 2 3.1.7 1.3.8 2 .8 2.3 0 2.5-2.1 4.6-4.6 4.6z"
        })),
            De = Te,
            Fe = (0, c.createElement)(v.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, c.createElement)(v.Path, {
          d: "M19 6H6c-1.1 0-2 .9-2 2v9c0 1.1.9 2 2 2h13c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zM6 17.5c-.3 0-.5-.2-.5-.5V8c0-.3.2-.5.5-.5h3v10H6zm13.5-.5c0 .3-.2.5-.5.5h-3v-10h3c.3 0 .5.2.5.5v9z"
        })),
            We = Fe,
            Ne = (0, c.createElement)(v.SVG, {
          viewBox: "0 0 24 24",
          xmlns: "http://www.w3.org/2000/svg"
        }, (0, c.createElement)(v.Path, {
          d: "M19 6H6c-1.1 0-2 .9-2 2v9c0 1.1.9 2 2 2h13c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm-4.1 1.5v10H10v-10h4.9zM5.5 17V8c0-.3.2-.5.5-.5h2.5v10H6c-.3 0-.5-.2-.5-.5zm14 0c0 .3-.2.5-.5.5h-2.6v-10H19c.3 0 .5.2.5.5v9z"
        })),
            Ue = Ne,
            Je = (0, c.createElement)(v.SVG, {
          viewBox: "0 0 24 24",
          xmlns: "http://www.w3.org/2000/svg"
        }, (0, c.createElement)(v.Path, {
          d: "M18 4H6c-1.1 0-2 .9-2 2v12.9c0 .6.5 1.1 1.1 1.1.3 0 .5-.1.8-.3L8.5 17H18c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm.5 11c0 .3-.2.5-.5.5H7.9l-2.4 2.4V6c0-.3.2-.5.5-.5h12c.3 0 .5.2.5.5v9z"
        })),
            Ke = Je,
            Qe = (0, c.createElement)(v.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, c.createElement)(v.Path, {
          d: "M7.25 16.4371C6.16445 15.2755 5.5 13.7153 5.5 12C5.5 8.41015 8.41015 5.5 12 5.5C15.5899 5.5 18.5 8.41015 18.5 12C18.5 13.7153 17.8356 15.2755 16.75 16.4371V16C16.75 14.4812 15.5188 13.25 14 13.25L10 13.25C8.48122 13.25 7.25 14.4812 7.25 16V16.4371ZM8.75 17.6304C9.70606 18.1835 10.8161 18.5 12 18.5C13.1839 18.5 14.2939 18.1835 15.25 17.6304V16C15.25 15.3096 14.6904 14.75 14 14.75L10 14.75C9.30964 14.75 8.75 15.3096 8.75 16V17.6304ZM4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12ZM14 10C14 11.1046 13.1046 12 12 12C10.8954 12 10 11.1046 10 10C10 8.89543 10.8954 8 12 8C13.1046 8 14 8.89543 14 10Z",
          fillRule: "evenodd",
          clipRule: "evenodd",
          fill: "black"
        })),
            Xe = Qe,
            Ye = (0, c.createElement)(v.SVG, {
          viewBox: "0 0 24 24",
          xmlns: "http://www.w3.org/2000/svg",
          fill: "#FFFFFF"
        }, (0, c.createElement)(v.Path, {
          d: "M18 4H6c-1.1 0-2 .9-2 2v12.9c0 .6.5 1.1 1.1 1.1.3 0 .5-.1.8-.3L8.5 17H18c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm.5 11c0 .3-.2.5-.5.5H7.9l-2.4 2.4V6c0-.3.2-.5.5-.5h12c.3 0 .5.2.5.5v9z",
          fillRule: "evenodd",
          clipRule: "evenodd"
        }), (0, c.createElement)(v.Path, {
          d: "M15 15V15C15 13.8954 14.1046 13 13 13L11 13C9.89543 13 9 13.8954 9 15V15",
          fillRule: "evenodd",
          clipRule: "evenodd"
        }), (0, c.createElement)(v.Circle, {
          cx: "12",
          cy: "9",
          r: "2",
          fillRule: "evenodd",
          clipRule: "evenodd"
        })),
            $e = Ye,
            et = (0, c.createElement)(v.SVG, {
          viewBox: "0 0 24 24",
          xmlns: "http://www.w3.org/2000/svg"
        }, (0, c.createElement)(v.Path, {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M6.68822 16.625L5.5 17.8145L5.5 5.5L18.5 5.5L18.5 16.625L6.68822 16.625ZM7.31 18.125L19 18.125C19.5523 18.125 20 17.6773 20 17.125L20 5C20 4.44772 19.5523 4 19 4H5C4.44772 4 4 4.44772 4 5V19.5247C4 19.8173 4.16123 20.086 4.41935 20.2237C4.72711 20.3878 5.10601 20.3313 5.35252 20.0845L7.31 18.125ZM16 9.99997H8V8.49997H16V9.99997ZM8 14H13V12.5H8V14Z"
        })),
            tt = et,
            lt = (0, c.createElement)(v.SVG, {
          width: "24",
          height: "24",
          viewBox: "0 0 24 24",
          xmlns: "http://www.w3.org/2000/svg"
        }, (0, c.createElement)(v.Path, {
          d: "M6.68822 10.625L6.24878 11.0649L5.5 11.8145L5.5 5.5L12.5 5.5V8L14 6.5V5C14 4.44772 13.5523 4 13 4H5C4.44772 4 4 4.44771 4 5V13.5247C4 13.8173 4.16123 14.086 4.41935 14.2237C4.72711 14.3878 5.10601 14.3313 5.35252 14.0845L7.31 12.125H8.375L9.875 10.625H7.31H6.68822ZM14.5605 10.4983L11.6701 13.75H16.9975C17.9963 13.75 18.7796 14.1104 19.3553 14.7048C19.9095 15.2771 20.2299 16.0224 20.4224 16.7443C20.7645 18.0276 20.7543 19.4618 20.7487 20.2544C20.7481 20.345 20.7475 20.4272 20.7475 20.4999L19.2475 20.5001C19.2475 20.4191 19.248 20.3319 19.2484 20.2394V20.2394C19.2526 19.4274 19.259 18.2035 18.973 17.1307C18.8156 16.5401 18.586 16.0666 18.2778 15.7483C17.9909 15.4521 17.5991 15.25 16.9975 15.25H11.8106L14.5303 17.9697L13.4696 19.0303L8.96956 14.5303L13.4394 9.50171L14.5605 10.4983Z"
        })),
            ct = lt,
            ht = (0, c.createElement)(v.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, c.createElement)(v.Path, {
          d: "M18.7 3H5.3C4 3 3 4 3 5.3v13.4C3 20 4 21 5.3 21h13.4c1.3 0 2.3-1 2.3-2.3V5.3C21 4 20 3 18.7 3zm.8 15.7c0 .4-.4.8-.8.8H5.3c-.4 0-.8-.4-.8-.8V5.3c0-.4.4-.8.8-.8h6.2v8.9l2.5-3.1 2.5 3.1V4.5h2.2c.4 0 .8.4.8.8v13.4z"
        })),
            vt = ht,
            at = (0, c.createElement)(v.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, c.createElement)(v.Path, {
          d: "M16 11.2h-3.2V8h-1.6v3.2H8v1.6h3.2V16h1.6v-3.2H16z"
        })),
            rt = at,
            wt = (0, c.createElement)(v.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, c.createElement)(v.Path, {
          d: "M16.5 7.8v7H18v-7c0-1-.8-1.8-1.8-1.8h-7v1.5h7c.2 0 .3.1.3.3zm-8.7 8.7c-.1 0-.2-.1-.2-.2V2H6v4H2v1.5h4v8.8c0 1 .8 1.8 1.8 1.8h8.8v4H18v-4h4v-1.5H7.8z"
        })),
            nt = wt,
            mt = (0, c.createElement)(v.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, c.createElement)(v.Path, {
          d: "M3.25 12a8.75 8.75 0 1117.5 0 8.75 8.75 0 01-17.5 0zM12 4.75a7.25 7.25 0 100 14.5 7.25 7.25 0 000-14.5zm-1.338 4.877c-.314.22-.412.452-.412.623 0 .171.098.403.412.623.312.218.783.377 1.338.377.825 0 1.605.233 2.198.648.59.414 1.052 1.057 1.052 1.852 0 .795-.461 1.438-1.052 1.852-.41.286-.907.486-1.448.582v.316a.75.75 0 01-1.5 0v-.316a3.64 3.64 0 01-1.448-.582c-.59-.414-1.052-1.057-1.052-1.852a.75.75 0 011.5 0c0 .171.098.403.412.623.312.218.783.377 1.338.377s1.026-.159 1.338-.377c.314-.22.412-.452.412-.623 0-.171-.098-.403-.412-.623-.312-.218-.783-.377-1.338-.377-.825 0-1.605-.233-2.198-.648-.59-.414-1.052-1.057-1.052-1.852 0-.795.461-1.438 1.052-1.852a3.64 3.64 0 011.448-.582V7.5a.75.75 0 011.5 0v.316c.54.096 1.039.296 1.448.582.59.414 1.052 1.057 1.052 1.852a.75.75 0 01-1.5 0c0-.171-.098-.403-.412-.623-.312-.218-.783-.377-1.338-.377s-1.026.159-1.338.377z"
        })),
            ot = mt,
            st = (0, c.createElement)(v.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, c.createElement)(v.Path, {
          d: "M12 3.25a8.75 8.75 0 100 17.5 8.75 8.75 0 000-17.5zM4.75 12a7.25 7.25 0 1114.5 0 7.25 7.25 0 01-14.5 0zm9.195 1.944a2.75 2.75 0 01-4.066-.194h.621a.75.75 0 000-1.5H9.262a2.767 2.767 0 010-.5H11.5a.75.75 0 000-1.5H9.88a2.75 2.75 0 014.066-.194.75.75 0 001.06-1.061 4.25 4.25 0 00-6.88 1.255H7.5a.75.75 0 000 1.5h.258c-.01.166-.01.334 0 .5H7.5a.75.75 0 000 1.5h.626a4.25 4.25 0 006.88 1.255.75.75 0 00-1.06-1.06z"
        })),
            it = st,
            Vt = (0, c.createElement)(v.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, c.createElement)(v.Path, {
          fillRule: "evenodd",
          d: "M3.25 12a8.75 8.75 0 1117.5 0 8.75 8.75 0 01-17.5 0zM12 4.75a7.25 7.25 0 100 14.5 7.25 7.25 0 000-14.5zm.25 4c-.787 0-1.425.638-1.425 1.425 0 .058.014.147.069.3.04.113.088.223.147.36a26.094 26.094 0 01.173.415H12.5a.75.75 0 010 1.5h-.953c.002.047.003.095.003.144 0 .617-.236 1.168-.511 1.606h3.386a.75.75 0 010 1.5H9.35a.75.75 0 01-.452-1.349l.007-.005a4.417 4.417 0 00.596-.581c.328-.39.549-.806.549-1.171 0-.05-.002-.097-.004-.144H9.5a.75.75 0 010-1.5h.088a5.875 5.875 0 01-.106-.27 2.382 2.382 0 01-.157-.805 2.925 2.925 0 015.637-1.097.75.75 0 01-1.39.563 1.426 1.426 0 00-1.322-.891zm-3.35 5.9l.45.6-.45-.6z"
        })),
            zt = Vt,
            dt = (0, c.createElement)(v.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, c.createElement)(v.Path, {
          d: "M4 20h9v-1.5H4V20zm0-5.5V16h16v-1.5H4zm.8-4l.7.7 2-2V12h1V9.2l2 2 .7-.7-2-2H12v-1H9.2l2-2-.7-.7-2 2V4h-1v2.8l-2-2-.7.7 2 2H4v1h2.8l-2 2z"
        })),
            gt = dt,
            Et = (0, c.createElement)(v.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, c.createElement)(v.Path, {
          d: "M20.5 16h-.7V8c0-1.1-.9-2-2-2H6.2c-1.1 0-2 .9-2 2v8h-.7c-.8 0-1.5.7-1.5 1.5h20c0-.8-.7-1.5-1.5-1.5zM5.7 8c0-.3.2-.5.5-.5h11.6c.3 0 .5.2.5.5v7.6H5.7V8z"
        })),
            Ht = Et,
            xt = (0, c.createElement)(v.SVG, {
          width: "18",
          height: "18",
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 18 18"
        }, (0, c.createElement)(v.Path, {
          d: "M5 4h2V2H5v2zm6-2v2h2V2h-2zm-6 8h2V8H5v2zm6 0h2V8h-2v2zm-6 6h2v-2H5v2zm6 0h2v-2h-2v2z"
        })),
            pt = xt,
            Mt = (0, c.createElement)(v.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, c.createElement)(v.Path, {
          d: "M18 11.3l-1-1.1-4 4V3h-1.5v11.3L7 10.2l-1 1.1 6.2 5.8 5.8-5.8zm.5 3.7v3.5h-13V15H4v5h16v-5h-1.5z"
        })),
            ut = Mt,
            Bt = (0, c.createElement)(v.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, c.createElement)(v.Path, {
          d: "M20.1 5.1L16.9 2 6.2 12.7l-1.3 4.4 4.5-1.3L20.1 5.1zM4 20.8h8v-1.5H4v1.5z"
        })),
            St = Bt,
            Lt = St,
            Pt = (0, c.createElement)(v.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, c.createElement)(v.Path, {
          d: "M18.2 17c0 .7-.6 1.2-1.2 1.2H7c-.7 0-1.2-.6-1.2-1.2V7c0-.7.6-1.2 1.2-1.2h3.2V4.2H7C5.5 4.2 4.2 5.5 4.2 7v10c0 1.5 1.2 2.8 2.8 2.8h10c1.5 0 2.8-1.2 2.8-2.8v-3.6h-1.5V17zM14.9 3v1.5h3.7l-6.4 6.4 1.1 1.1 6.4-6.4v3.7h1.5V3h-6.3z"
        })),
            Gt = Pt,
            Ct = (0, c.createElement)(v.SVG, {
          viewBox: "0 0 24 24",
          xmlns: "http://www.w3.org/2000/svg"
        }, (0, c.createElement)(v.Path, {
          d: "M19 6.2h-5.9l-.6-1.1c-.3-.7-1-1.1-1.8-1.1H5c-1.1 0-2 .9-2 2v11.8c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V8.2c0-1.1-.9-2-2-2zm.5 11.6c0 .3-.2.5-.5.5H5c-.3 0-.5-.2-.5-.5V6c0-.3.2-.5.5-.5h5.8c.2 0 .4.1.4.3l1 2H19c.3 0 .5.2.5.5v9.5z"
        })),
            ft = Ct,
            bt = (0, c.createElement)(v.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, c.createElement)(v.Path, {
          d: "M4 6v12c0 1.1.9 2 2 2h3v-1.5H6c-.3 0-.5-.2-.5-.5V6c0-.3.2-.5.5-.5h3V4H6c-1.1 0-2 .9-2 2zm7.2 16h1.5V2h-1.5v20zM15 5.5h1.5V4H15v1.5zm3.5.5H20c0-1.1-.9-2-2-2v1.5c.3 0 .5.2.5.5zm0 10.5H20v-2h-1.5v2zm0-3.5H20v-2h-1.5v2zm-.5 5.5V20c1.1 0 2-.9 2-2h-1.5c0 .3-.2.5-.5.5zM15 20h1.5v-1.5H15V20zm3.5-10.5H20v-2h-1.5v2z"
        })),
            _t = bt,
            Rt = (0, c.createElement)(v.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, c.createElement)(v.Path, {
          d: "M2 11.2v1.5h20v-1.5H2zM5.5 6c0-.3.2-.5.5-.5h12c.3 0 .5.2.5.5v3H20V6c0-1.1-.9-2-2-2H6c-1.1 0-2 .9-2 2v3h1.5V6zm2 14h2v-1.5h-2V20zm3.5 0h2v-1.5h-2V20zm7-1.5V20c1.1 0 2-.9 2-2h-1.5c0 .3-.2.5-.5.5zm.5-2H20V15h-1.5v1.5zM5.5 18H4c0 1.1.9 2 2 2v-1.5c-.3 0-.5-.2-.5-.5zm0-3H4v1.5h1.5V15zm9 5h2v-1.5h-2V20z"
        })),
            kt = Rt,
            yt = (0, c.createElement)(v.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, c.createElement)(v.Path, {
          d: "M14.7 11.3c1-.6 1.5-1.6 1.5-3 0-2.3-1.3-3.4-4-3.4H7v14h5.8c1.4 0 2.5-.3 3.3-1 .8-.7 1.2-1.7 1.2-2.9.1-1.9-.8-3.1-2.6-3.7zm-5.1-4h2.3c.6 0 1.1.1 1.4.4.3.3.5.7.5 1.2s-.2 1-.5 1.2c-.3.3-.8.4-1.4.4H9.6V7.3zm4.6 9c-.4.3-1 .4-1.7.4H9.6v-3.9h2.9c.7 0 1.3.2 1.7.5.4.3.6.8.6 1.5s-.2 1.2-.6 1.5z"
        })),
            Zt = yt,
            It = (0, c.createElement)(v.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, c.createElement)(v.Path, {
          d: "M7.1 6.8L3.1 18h1.6l1.1-3h4.3l1.1 3h1.6l-4-11.2H7.1zm-.8 6.8L8 8.9l1.7 4.7H6.3zm14.5-1.5c-.3-.6-.7-1.1-1.2-1.5-.6-.4-1.2-.6-1.9-.6-.5 0-.9.1-1.4.3-.4.2-.8.5-1.1.8V6h-1.4v12h1.3l.2-1c.2.4.6.6 1 .8.4.2.9.3 1.4.3.7 0 1.2-.2 1.8-.5.5-.4 1-.9 1.3-1.5.3-.6.5-1.3.5-2.1-.1-.6-.2-1.3-.5-1.9zm-1.7 4c-.4.5-.9.8-1.6.8s-1.2-.2-1.7-.7c-.4-.5-.7-1.2-.7-2.1 0-.9.2-1.6.7-2.1.4-.5 1-.7 1.7-.7s1.2.3 1.6.8c.4.5.6 1.2.6 2 .1.8-.2 1.4-.6 2z"
        })),
            At = It,
            qt = (0, c.createElement)(v.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, c.createElement)(v.Path, {
          d: "M4 7.2v1.5h16V7.2H4zm8 8.6h8v-1.5h-8v1.5zm-8-3.5l3 3-3 3 1 1 4-4-4-4-1 1z"
        })),
            Ot = qt,
            jt = (0, c.createElement)(v.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, c.createElement)(v.Path, {
          d: "M20 5.5H4V4H20V5.5ZM12 12.5H4V11H12V12.5ZM20 20V18.5H4V20H20ZM20.0303 9.03033L17.0607 12L20.0303 14.9697L18.9697 16.0303L15.4697 12.5303L14.9393 12L15.4697 11.4697L18.9697 7.96967L20.0303 9.03033Z"
        })),
            Tt = jt,
            Dt = (0, c.createElement)(v.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, c.createElement)(v.Path, {
          d: "M12.5 5L10 19h1.9l2.5-14z"
        })),
            Ft = Dt,
            Wt = (0, c.createElement)(v.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, c.createElement)(v.Path, {
          d: "M11.1 15.8H20v-1.5h-8.9v1.5zm0-8.6v1.5H20V7.2h-8.9zM6 13c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0-7c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
        })),
            Nt = Wt,
            Ut = (0, c.createElement)(v.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, c.createElement)(v.Path, {
          d: "M4 8.8h8.9V7.2H4v1.6zm0 7h8.9v-1.5H4v1.5zM18 13c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0-3c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2z"
        })),
            Jt = Ut,
            Kt = (0, c.createElement)(v.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, c.createElement)(v.Path, {
          d: "M11.1 15.8H20v-1.5h-8.9v1.5zm0-8.6v1.5H20V7.2h-8.9zM5 6.7V10h1V5.3L3.8 6l.4 1 .8-.3zm-.4 5.7c-.3.1-.5.2-.7.3l.1 1.1c.2-.2.5-.4.8-.5.3-.1.6 0 .7.1.2.3 0 .8-.2 1.1-.5.8-.9 1.6-1.4 2.5h2.7v-1h-1c.3-.6.8-1.4.9-2.1.1-.3 0-.8-.2-1.1-.5-.6-1.3-.5-1.7-.4z"
        })),
            Qt = Kt,
            Xt = (0, c.createElement)(v.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, c.createElement)(v.Path, {
          d: "M3.8 15.8h8.9v-1.5H3.8v1.5zm0-7h8.9V7.2H3.8v1.6zm14.7-2.1V10h1V5.3l-2.2.7.3 1 .9-.3zm1.2 6.1c-.5-.6-1.2-.5-1.7-.4-.3.1-.5.2-.7.3l.1 1.1c.2-.2.5-.4.8-.5.3-.1.6 0 .7.1.2.3 0 .8-.2 1.1-.5.8-.9 1.6-1.4 2.5H20v-1h-.9c.3-.6.8-1.4.9-2.1 0-.3 0-.8-.3-1.1z"
        })),
            Yt = Xt,
            $t = (0, c.createElement)(v.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "-2 -2 24 24"
        }, (0, c.createElement)(v.Path, {
          d: "M5.52 2h7.43c.55 0 1 .45 1 1s-.45 1-1 1h-1v13c0 .55-.45 1-1 1s-1-.45-1-1V5c0-.55-.45-1-1-1s-1 .45-1 1v12c0 .55-.45 1-1 1s-1-.45-1-1v-5.96h-.43C3.02 11.04 1 9.02 1 6.52S3.02 2 5.52 2zM14 14l5-4-5-4v8z"
        })),
            el = $t,
            tl = (0, c.createElement)(v.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, c.createElement)(v.Path, {
          d: "M11 16.8c-.1-.1-.2-.3-.3-.5v-2.6c0-.9-.1-1.7-.3-2.2-.2-.5-.5-.9-.9-1.2-.4-.2-.9-.3-1.6-.3-.5 0-1 .1-1.5.2s-.9.3-1.2.6l.2 1.2c.4-.3.7-.4 1.1-.5.3-.1.7-.2 1-.2.6 0 1 .1 1.3.4.3.2.4.7.4 1.4-1.2 0-2.3.2-3.3.7s-1.4 1.1-1.4 2.1c0 .7.2 1.2.7 1.6.4.4 1 .6 1.8.6.9 0 1.7-.4 2.4-1.2.1.3.2.5.4.7.1.2.3.3.6.4.3.1.6.1 1.1.1h.1l.2-1.2h-.1c-.4.1-.6 0-.7-.1zM9.2 16c-.2.3-.5.6-.9.8-.3.1-.7.2-1.1.2-.4 0-.7-.1-.9-.3-.2-.2-.3-.5-.3-.9 0-.6.2-1 .7-1.3.5-.3 1.3-.4 2.5-.5v2zm10.6-3.9c-.3-.6-.7-1.1-1.2-1.5-.6-.4-1.2-.6-1.9-.6-.5 0-.9.1-1.4.3-.4.2-.8.5-1.1.8V6h-1.4v12h1.3l.2-1c.2.4.6.6 1 .8.4.2.9.3 1.4.3.7 0 1.2-.2 1.8-.5.5-.4 1-.9 1.3-1.5.3-.6.5-1.3.5-2.1-.1-.6-.2-1.3-.5-1.9zm-1.7 4c-.4.5-.9.8-1.6.8s-1.2-.2-1.7-.7c-.4-.5-.7-1.2-.7-2.1 0-.9.2-1.6.7-2.1.4-.5 1-.7 1.7-.7s1.2.3 1.6.8c.4.5.6 1.2.6 2s-.2 1.4-.6 2z"
        })),
            ll = tl,
            cl = (0, c.createElement)(v.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, c.createElement)(v.Path, {
          d: "M4 7.2v1.5h16V7.2H4zm8 8.6h8v-1.5h-8v1.5zm-4-4.6l-4 4 4 4 1-1-3-3 3-3-1-1z"
        })),
            hl = cl,
            vl = (0, c.createElement)(v.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, c.createElement)(v.Path, {
          d: "M20 5.5H4V4H20V5.5ZM12 12.5H4V11H12V12.5ZM20 20V18.5H4V20H20ZM15.4697 14.9697L18.4393 12L15.4697 9.03033L16.5303 7.96967L20.0303 11.4697L20.5607 12L20.0303 12.5303L16.5303 16.0303L15.4697 14.9697Z"
        })),
            al = vl,
            rl = (0, c.createElement)(v.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "-2 -2 24 24"
        }, (0, c.createElement)(v.Path, {
          d: "M5.52 2h7.43c.55 0 1 .45 1 1s-.45 1-1 1h-1v13c0 .55-.45 1-1 1s-1-.45-1-1V5c0-.55-.45-1-1-1s-1 .45-1 1v12c0 .55-.45 1-1 1s-1-.45-1-1v-5.96h-.43C3.02 11.04 1 9.02 1 6.52S3.02 2 5.52 2zM19 6l-5 4 5 4V6zM5.52 2h7.43c.55 0 1 .45 1 1s-.45 1-1 1h-1v13c0 .55-.45 1-1 1s-1-.45-1-1V5c0-.55-.45-1-1-1s-1 .45-1 1v12c0 .55-.45 1-1 1s-1-.45-1-1v-5.96h-.43C3.02 11.04 1 9.02 1 6.52S3.02 2 5.52 2zM19 6l-5 4 5 4V6z"
        })),
            wl = rl,
            nl = (0, c.createElement)(v.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, c.createElement)(v.Path, {
          d: "M9.1 9v-.5c0-.6.2-1.1.7-1.4.5-.3 1.2-.5 2-.5.7 0 1.4.1 2.1.3.7.2 1.4.5 2.1.9l.2-1.9c-.6-.3-1.2-.5-1.9-.7-.8-.1-1.6-.2-2.4-.2-1.5 0-2.7.3-3.6 1-.8.7-1.2 1.5-1.2 2.6V9h2zM20 12H4v1h8.3c.3.1.6.2.8.3.5.2.9.5 1.1.8.3.3.4.7.4 1.2 0 .7-.2 1.1-.8 1.5-.5.3-1.2.5-2.1.5-.8 0-1.6-.1-2.4-.3-.8-.2-1.5-.5-2.2-.8L7 18.1c.5.2 1.2.4 2 .6.8.2 1.6.3 2.4.3 1.7 0 3-.3 3.9-1 .9-.7 1.3-1.6 1.3-2.8 0-.9-.2-1.7-.7-2.2H20v-1z"
        })),
            ml = nl,
            ol = (0, c.createElement)(v.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, c.createElement)(v.Path, {
          d: "M7 18v1h10v-1H7zm5-2c1.5 0 2.6-.4 3.4-1.2.8-.8 1.1-2 1.1-3.5V5H15v5.8c0 1.2-.2 2.1-.6 2.8-.4.7-1.2 1-2.4 1s-2-.3-2.4-1c-.4-.7-.6-1.6-.6-2.8V5H7.5v6.2c0 1.5.4 2.7 1.1 3.5.8.9 1.9 1.3 3.4 1.3z"
        })),
            sl = ol,
            il = (0, c.createElement)(v.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, c.createElement)(v.Path, {
          d: "M6.1 6.8L2.1 18h1.6l1.1-3h4.3l1.1 3h1.6l-4-11.2H6.1zm-.8 6.8L7 8.9l1.7 4.7H5.3zm15.1-.7c-.4-.5-.9-.8-1.6-1 .4-.2.7-.5.8-.9.2-.4.3-.9.3-1.4 0-.9-.3-1.6-.8-2-.6-.5-1.3-.7-2.4-.7h-3.5V18h4.2c1.1 0 2-.3 2.6-.8.6-.6 1-1.4 1-2.4-.1-.8-.3-1.4-.6-1.9zm-5.7-4.7h1.8c.6 0 1.1.1 1.4.4.3.2.5.7.5 1.3 0 .6-.2 1.1-.5 1.3-.3.2-.8.4-1.4.4h-1.8V8.2zm4 8c-.4.3-.9.5-1.5.5h-2.6v-3.8h2.6c1.4 0 2 .6 2 1.9.1.6-.1 1-.5 1.4z"
        })),
            Vl = il,
            zl = (0, c.createElement)(v.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, c.createElement)(v.Path, {
          d: "M4.2 9h1.5V5.8H9V4.2H4.2V9zm14 9.2H15v1.5h4.8V15h-1.5v3.2zM15 4.2v1.5h3.2V9h1.5V4.2H15zM5.8 15H4.2v4.8H9v-1.5H5.8V15z"
        })),
            dl = zl,
            gl = (0, c.createElement)(v.SVG, {
          viewBox: "0 0 24 24",
          xmlns: "http://www.w3.org/2000/svg"
        }, (0, c.createElement)(v.Path, {
          d: "M20.2 8v11c0 .7-.6 1.2-1.2 1.2H6v1.5h13c1.5 0 2.7-1.2 2.7-2.8V8h-1.5zM18 16.4V4.6c0-.9-.7-1.6-1.6-1.6H4.6C3.7 3 3 3.7 3 4.6v11.8c0 .9.7 1.6 1.6 1.6h11.8c.9 0 1.6-.7 1.6-1.6zM4.5 4.6c0-.1.1-.1.1-.1h11.8c.1 0 .1.1.1.1V12l-2.3-1.7c-.3-.2-.6-.2-.9 0l-2.9 2.1L8 11.3c-.2-.1-.5-.1-.7 0l-2.9 1.5V4.6zm0 11.8v-1.8l3.2-1.7 2.4 1.2c.2.1.5.1.8-.1l2.8-2 2.8 2v2.5c0 .1-.1.1-.1.1H4.6c0-.1-.1-.2-.1-.2z"
        })),
            El = gl,
            Hl = (0, c.createElement)(v.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, c.createElement)(v.Path, {
          d: "M12 3.3c-4.8 0-8.8 3.9-8.8 8.8 0 4.8 3.9 8.8 8.8 8.8 4.8 0 8.8-3.9 8.8-8.8s-4-8.8-8.8-8.8zm6.5 5.5h-2.6C15.4 7.3 14.8 6 14 5c2 .6 3.6 2 4.5 3.8zm.7 3.2c0 .6-.1 1.2-.2 1.8h-2.9c.1-.6.1-1.2.1-1.8s-.1-1.2-.1-1.8H19c.2.6.2 1.2.2 1.8zM12 18.7c-1-.7-1.8-1.9-2.3-3.5h4.6c-.5 1.6-1.3 2.9-2.3 3.5zm-2.6-4.9c-.1-.6-.1-1.1-.1-1.8 0-.6.1-1.2.1-1.8h5.2c.1.6.1 1.1.1 1.8s-.1 1.2-.1 1.8H9.4zM4.8 12c0-.6.1-1.2.2-1.8h2.9c-.1.6-.1 1.2-.1 1.8 0 .6.1 1.2.1 1.8H5c-.2-.6-.2-1.2-.2-1.8zM12 5.3c1 .7 1.8 1.9 2.3 3.5H9.7c.5-1.6 1.3-2.9 2.3-3.5zM10 5c-.8 1-1.4 2.3-1.8 3.8H5.5C6.4 7 8 5.6 10 5zM5.5 15.3h2.6c.4 1.5 1 2.8 1.8 3.7-1.8-.6-3.5-2-4.4-3.7zM14 19c.8-1 1.4-2.2 1.8-3.7h2.6C17.6 17 16 18.4 14 19z"
        })),
            xl = Hl,
            pl = (0, c.createElement)(v.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, c.createElement)(v.Path, {
          d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7.8 16.5H5c-.3 0-.5-.2-.5-.5v-6.2h6.8v6.7zm0-8.3H4.5V5c0-.3.2-.5.5-.5h6.2v6.7zm8.3 7.8c0 .3-.2.5-.5.5h-6.2v-6.8h6.8V19zm0-7.8h-6.8V4.5H19c.3 0 .5.2.5.5v6.2z",
          fillRule: "evenodd",
          clipRule: "evenodd"
        })),
            Ml = pl,
            ul = (0, c.createElement)(v.SVG, {
          viewBox: "0 0 24 24",
          xmlns: "http://www.w3.org/2000/svg"
        }, (0, c.createElement)(v.Path, {
          d: "M18 4h-7c-1.1 0-2 .9-2 2v3H6c-1.1 0-2 .9-2 2v7c0 1.1.9 2 2 2h7c1.1 0 2-.9 2-2v-3h3c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-4.5 14c0 .3-.2.5-.5.5H6c-.3 0-.5-.2-.5-.5v-7c0-.3.2-.5.5-.5h3V13c0 1.1.9 2 2 2h2.5v3zm0-4.5H11c-.3 0-.5-.2-.5-.5v-2.5H13c.3 0 .5.2.5.5v2.5zm5-.5c0 .3-.2.5-.5.5h-3V11c0-1.1-.9-2-2-2h-2.5V6c0-.3.2-.5.5-.5h7c.3 0 .5.2.5.5v7z"
        })),
            Bl = ul,
            Sl = (0, c.createElement)(v.SVG, {
          viewBox: "0 0 24 24",
          xmlns: "http://www.w3.org/2000/svg"
        }, (0, c.createElement)(v.Path, {
          d: "M7 16.5h10V15H7v1.5zm0-9V9h10V7.5H7z"
        })),
            Ll = Sl,
            Pl = (0, c.createElement)(v.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, c.createElement)(v.Path, {
          d: "M6.2 5.2v13.4l5.8-4.8 5.8 4.8V5.2z"
        })),
            Gl = Pl,
            Cl = (0, c.createElement)(v.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, c.createElement)(v.Path, {
          d: "M12 4.75a7.25 7.25 0 100 14.5 7.25 7.25 0 000-14.5zM3.25 12a8.75 8.75 0 1117.5 0 8.75 8.75 0 01-17.5 0zM12 8.75a1.5 1.5 0 01.167 2.99c-.465.052-.917.44-.917 1.01V14h1.5v-.845A3 3 0 109 10.25h1.5a1.5 1.5 0 011.5-1.5zM11.25 15v1.5h1.5V15h-1.5z"
        })),
            fl = Cl,
            bl = (0, c.createElement)(v.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24",
          width: "24",
          height: "24"
        }, (0, c.createElement)(v.Path, {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2zm-1 16v-2h2v2h-2zm2-3v-1.141A3.991 3.991 0 0016 10a4 4 0 00-8 0h2c0-1.103.897-2 2-2s2 .897 2 2-.897 2-2 2a1 1 0 00-1 1v2h2z"
        })),
            _l = bl,
            Rl = (0, c.createElement)(v.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, c.createElement)(v.Path, {
          fillRule: "evenodd",
          d: "M6 5.5h12a.5.5 0 01.5.5v7H14a2 2 0 11-4 0H5.5V6a.5.5 0 01.5-.5zm-.5 9V18a.5.5 0 00.5.5h12a.5.5 0 00.5-.5v-3.5h-3.337a3.5 3.5 0 01-6.326 0H5.5zM4 13V6a2 2 0 012-2h12a2 2 0 012 2v12a2 2 0 01-2 2H6a2 2 0 01-2-2v-5z",
          clipRule: "evenodd"
        })),
            kl = Rl,
            yl = (0, c.createElement)(v.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, c.createElement)(v.Path, {
          fillRule: "evenodd",
          d: "M18.646 9H20V8l-1-.5L12 4 5 7.5 4 8v1h14.646zm-3-1.5L12 5.677 8.354 7.5h7.292zm-7.897 9.44v-6.5h-1.5v6.5h1.5zm5-6.5v6.5h-1.5v-6.5h1.5zm5 0v6.5h-1.5v-6.5h1.5zm2.252 8.81c0 .414-.334.75-.748.75H4.752a.75.75 0 010-1.5h14.5a.75.75 0 01.749.75z",
          clipRule: "evenodd"
        })),
            Zl = yl,
            Il = (0, c.createElement)(v.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, c.createElement)(v.Path, {
          d: "M12 4L4 7.9V20h16V7.9L12 4zm6.5 14.5H14V13h-4v5.5H5.5V8.8L12 5.7l6.5 3.1v9.7z"
        })),
            Al = Il,
            ql = (0, c.createElement)(v.SVG, {
          viewBox: "0 0 24 24",
          xmlns: "http://www.w3.org/2000/svg"
        }, (0, c.createElement)(v.Path, {
          d: "M4.8 11.4H2.1V9H1v6h1.1v-2.6h2.7V15h1.1V9H4.8v2.4zm1.9-1.3h1.7V15h1.1v-4.9h1.7V9H6.7v1.1zM16.2 9l-1.5 2.7L13.3 9h-.9l-.8 6h1.1l.5-4 1.5 2.8 1.5-2.8.5 4h1.1L17 9h-.8zm3.8 5V9h-1.1v6h3.6v-1H20z"
        })),
            Ol = ql,
            jl = (0, c.createElement)(v.SVG, {
          viewBox: "0 0 24 24",
          xmlns: "http://www.w3.org/2000/svg"
        }, (0, c.createElement)(v.Path, {
          d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM5 4.5h14c.3 0 .5.2.5.5v8.4l-3-2.9c-.3-.3-.8-.3-1 0L11.9 14 9 12c-.3-.2-.6-.2-.8 0l-3.6 2.6V5c-.1-.3.1-.5.4-.5zm14 15H5c-.3 0-.5-.2-.5-.5v-2.4l4.1-3 3 1.9c.3.2.7.2.9-.1L16 12l3.5 3.4V19c0 .3-.2.5-.5.5z"
        })),
            Tl = jl,
            Dl = (0, c.createElement)(v.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, c.createElement)(v.Path, {
          d: "M12 3.2c-4.8 0-8.8 3.9-8.8 8.8 0 4.8 3.9 8.8 8.8 8.8 4.8 0 8.8-3.9 8.8-8.8 0-4.8-4-8.8-8.8-8.8zm0 16c-4 0-7.2-3.3-7.2-7.2C4.8 8 8 4.8 12 4.8s7.2 3.3 7.2 7.2c0 4-3.2 7.2-7.2 7.2zM11 17h2v-6h-2v6zm0-8h2V7h-2v2z"
        })),
            Fl = Dl,
            Wl = (0, c.createElement)(v.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "-2 -2 24 24"
        }, (0, c.createElement)(v.Path, {
          d: "M9 12h2v-2h2V8h-2V6H9v2H7v2h2v2zm1 4c3.9 0 7-3.1 7-7s-3.1-7-7-7-7 3.1-7 7 3.1 7 7 7zm0-12c2.8 0 5 2.2 5 5s-2.2 5-5 5-5-2.2-5-5 2.2-5 5-5zM3 19h14v-2H3v2z"
        })),
            Nl = Wl,
            Ul = (0, c.createElement)(v.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "-2 -2 24 24"
        }, (0, c.createElement)(v.Path, {
          d: "M11 8H9v2H7v2h2v2h2v-2h2v-2h-2V8zm-1-4c-3.9 0-7 3.1-7 7s3.1 7 7 7 7-3.1 7-7-3.1-7-7-7zm0 12c-2.8 0-5-2.2-5-5s2.2-5 5-5 5 2.2 5 5-2.2 5-5 5zM3 1v2h14V1H3z"
        })),
            Jl = Ul,
            Kl = (0, c.createElement)(v.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, c.createElement)(v.Path, {
          d: "M9 9v6h11V9H9zM4 20h1.5V4H4v16z"
        })),
            Ql = Kl,
            Xl = (0, c.createElement)(v.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, c.createElement)(v.Path, {
          d: "M20 9h-7.2V4h-1.6v5H4v6h7.2v5h1.6v-5H20z"
        })),
            Yl = Xl,
            $l = (0, c.createElement)(v.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, c.createElement)(v.Path, {
          d: "M4 15h11V9H4v6zM18.5 4v16H20V4h-1.5z"
        })),
            ec = $l,
            tc = (0, c.createElement)(v.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, c.createElement)(v.Path, {
          d: "M9 15h6V9H9v6zm-5 5h1.5V4H4v16zM18.5 4v16H20V4h-1.5z"
        })),
            lc = tc,
            cc = (0, c.createElement)(v.SVG, {
          viewBox: "0 0 24 24",
          xmlns: "http://www.w3.org/2000/svg"
        }, (0, c.createElement)(v.Path, {
          d: "M9 13.5a1.5 1.5 0 100-3 1.5 1.5 0 000 3zM9 16a4.002 4.002 0 003.8-2.75H15V16h2.5v-2.75H19v-2.5h-6.2A4.002 4.002 0 005 12a4 4 0 004 4z",
          fillRule: "evenodd",
          clipRule: "evenodd"
        })),
            hc = cc,
            vc = (0, c.createElement)(v.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "-2 -2 24 24"
        }, (0, c.createElement)(v.Path, {
          d: "M18,0 L2,0 C0.9,0 0.01,0.9 0.01,2 L0,12 C0,13.1 0.9,14 2,14 L18,14 C19.1,14 20,13.1 20,12 L20,2 C20,0.9 19.1,0 18,0 Z M18,12 L2,12 L2,2 L18,2 L18,12 Z M9,3 L11,3 L11,5 L9,5 L9,3 Z M9,6 L11,6 L11,8 L9,8 L9,6 Z M6,3 L8,3 L8,5 L6,5 L6,3 Z M6,6 L8,6 L8,8 L6,8 L6,6 Z M3,6 L5,6 L5,8 L3,8 L3,6 Z M3,3 L5,3 L5,5 L3,5 L3,3 Z M6,9 L14,9 L14,11 L6,11 L6,9 Z M12,6 L14,6 L14,8 L12,8 L12,6 Z M12,3 L14,3 L14,5 L12,5 L12,3 Z M15,6 L17,6 L17,8 L15,8 L15,6 Z M15,3 L17,3 L17,5 L15,5 L15,3 Z M10,20 L14,16 L6,16 L10,20 Z"
        })),
            ac = vc,
            rc = (0, c.createElement)(v.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "-2 -2 24 24"
        }, (0, c.createElement)(v.Path, {
          d: "M6.734 16.106l2.176-2.38-1.093-1.028-3.846 4.158 3.846 4.157 1.093-1.027-2.176-2.38h2.811c1.125 0 2.25.03 3.374 0 1.428-.001 3.362-.25 4.963-1.277 1.66-1.065 2.868-2.906 2.868-5.859 0-2.479-1.327-4.896-3.65-5.93-1.82-.813-3.044-.8-4.806-.788l-.567.002v1.5c.184 0 .368 0 .553-.002 1.82-.007 2.704-.014 4.21.657 1.854.827 2.76 2.657 2.76 4.561 0 2.472-.973 3.824-2.178 4.596-1.258.807-2.864 1.04-4.163 1.04h-.02c-1.115.03-2.229 0-3.344 0H6.734z"
        })),
            wc = rc,
            nc = (0, c.createElement)(v.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, c.createElement)(v.Path, {
          d: "M18 5.5H6a.5.5 0 00-.5.5v3h13V6a.5.5 0 00-.5-.5zm.5 5H10v8h8a.5.5 0 00.5-.5v-7.5zm-10 0h-3V18a.5.5 0 00.5.5h2.5v-8zM6 4h12a2 2 0 012 2v12a2 2 0 01-2 2H6a2 2 0 01-2-2V6a2 2 0 012-2z"
        })),
            mc = nc,
            oc = (0, c.createElement)(v.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, c.createElement)(v.Path, {
          fillRule: "evenodd",
          d: "M17.375 15.656A6.47 6.47 0 0018.5 12a6.47 6.47 0 00-.943-3.374l-1.262.813c.448.749.705 1.625.705 2.561a4.977 4.977 0 01-.887 2.844l1.262.813zm-1.951 1.87l-.813-1.261A4.976 4.976 0 0112 17c-.958 0-1.852-.27-2.613-.736l-.812 1.261A6.47 6.47 0 0012 18.5a6.47 6.47 0 003.424-.974zm-8.8-1.87A6.47 6.47 0 015.5 12c0-1.235.344-2.39.943-3.373l1.261.812A4.977 4.977 0 007 12c0 1.056.328 2.036.887 2.843l-1.262.813zm2.581-7.803A4.977 4.977 0 0112 7c1.035 0 1.996.314 2.794.853l.812-1.262A6.47 6.47 0 0012 5.5a6.47 6.47 0 00-3.607 1.092l.812 1.261zM12 20a8 8 0 100-16 8 8 0 000 16zm0-4.5a3.5 3.5 0 100-7 3.5 3.5 0 000 7z",
          clipRule: "evenodd"
        })),
            sc = oc,
            ic = (0, c.createElement)(v.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          width: "24",
          height: "24",
          fill: "none"
        }, (0, c.createElement)(v.Path, {
          fillRule: "evenodd",
          d: "M5 11.25h3v1.5H5v-1.5zm5.5 0h3v1.5h-3v-1.5zm8.5 0h-3v1.5h3v-1.5z",
          clipRule: "evenodd"
        })),
            Vc = ic,
            zc = (0, c.createElement)(v.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          width: "24",
          height: "24",
          fill: "none"
        }, (0, c.createElement)(v.Path, {
          fillRule: "evenodd",
          d: "M5.25 11.25h1.5v1.5h-1.5v-1.5zm3 0h1.5v1.5h-1.5v-1.5zm4.5 0h-1.5v1.5h1.5v-1.5zm1.5 0h1.5v1.5h-1.5v-1.5zm4.5 0h-1.5v1.5h1.5v-1.5z",
          clipRule: "evenodd"
        })),
            dc = zc,
            gc = (0, c.createElement)(v.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          width: "24",
          height: "24",
          fill: "none"
        }, (0, c.createElement)(v.Path, {
          d: "M5 11.25h14v1.5H5z"
        })),
            Ec = gc,
            Hc = (0, c.createElement)(v.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, c.createElement)(v.Path, {
          d: "M15.6 7.2H14v1.5h1.6c2 0 3.7 1.7 3.7 3.7s-1.7 3.7-3.7 3.7H14v1.5h1.6c2.8 0 5.2-2.3 5.2-5.2 0-2.9-2.3-5.2-5.2-5.2zM4.7 12.4c0-2 1.7-3.7 3.7-3.7H10V7.2H8.4c-2.9 0-5.2 2.3-5.2 5.2 0 2.9 2.3 5.2 5.2 5.2H10v-1.5H8.4c-2 0-3.7-1.7-3.7-3.7zm4.6.9h5.3v-1.5H9.3v1.5z"
        })),
            xc = Hc,
            pc = (0, c.createElement)(v.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, c.createElement)(v.Path, {
          d: "M15.6 7.3h-.7l1.6-3.5-.9-.4-3.9 8.5H9v1.5h2l-1.3 2.8H8.4c-2 0-3.7-1.7-3.7-3.7s1.7-3.7 3.7-3.7H10V7.3H8.4c-2.9 0-5.2 2.3-5.2 5.2 0 2.9 2.3 5.2 5.2 5.2H9l-1.4 3.2.9.4 5.7-12.5h1.4c2 0 3.7 1.7 3.7 3.7s-1.7 3.7-3.7 3.7H14v1.5h1.6c2.9 0 5.2-2.3 5.2-5.2 0-2.9-2.4-5.2-5.2-5.2z"
        })),
            Mc = pc,
            uc = (0, c.createElement)(v.SVG, {
          viewBox: "0 0 24 24",
          xmlns: "http://www.w3.org/2000/svg"
        }, (0, c.createElement)(v.Path, {
          d: "M4 4v1.5h16V4H4zm8 8.5h8V11h-8v1.5zM4 20h16v-1.5H4V20zm4-8c0-1.1-.9-2-2-2s-2 .9-2 2 .9 2 2 2 2-.9 2-2z"
        })),
            Bc = uc,
            Sc = (0, c.createElement)(v.SVG, {
          viewBox: "0 0 24 24",
          xmlns: "http://www.w3.org/2000/svg"
        }, (0, c.createElement)(v.Path, {
          d: "M13.8 5.2H3v1.5h10.8V5.2zm-3.6 12v1.5H21v-1.5H10.2zm7.2-6H6.6v1.5h10.8v-1.5z"
        })),
            Lc = Sc,
            Pc = (0, c.createElement)(v.SVG, {
          viewBox: "0 0 24 24",
          xmlns: "http://www.w3.org/2000/svg"
        }, (0, c.createElement)(v.Path, {
          d: "M8 5C8 3.34315 9.34315 2 11 2H13C14.6569 2 16 3.34315 16 5V9H18C19.2624 9 20 9.9804 20 11V19C20 20.0196 19.2624 21 18 21H6C4.73763 21 4 20.0196 4 19V11C4 9.9804 4.73763 9 6 9H8V5ZM9.5 9H14.5V5C14.5 4.17157 13.8284 3.5 13 3.5H11C10.1716 3.5 9.5 4.17157 9.5 5V9Z"
        })),
            Gc = Pc,
            Cc = (0, c.createElement)(v.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, c.createElement)(v.Path, {
          d: "M11 14.5l1.1 1.1 3-3 .5-.5-.6-.6-3-3-1 1 1.7 1.7H5v1.5h7.7L11 14.5zM16.8 5h-7c-1.1 0-2 .9-2 2v1.5h1.5V7c0-.3.2-.5.5-.5h7c.3 0 .5.2.5.5v10c0 .3-.2.5-.5.5h-7c-.3 0-.5-.2-.5-.5v-1.5H7.8V17c0 1.1.9 2 2 2h7c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2z"
        })),
            fc = Cc,
            bc = (0, c.createElement)(v.SVG, {
          viewBox: "0 0 24 24",
          xmlns: "http://www.w3.org/2000/svg"
        }, (0, c.createElement)(v.Path, {
          d: "M18.1823 11.6392C18.1823 13.0804 17.0139 14.2487 15.5727 14.2487C14.3579 14.2487 13.335 13.4179 13.0453 12.2922L13.0377 12.2625L13.0278 12.2335L12.3985 10.377L12.3942 10.3785C11.8571 8.64997 10.246 7.39405 8.33961 7.39405C5.99509 7.39405 4.09448 9.29465 4.09448 11.6392C4.09448 13.9837 5.99509 15.8843 8.33961 15.8843C8.88499 15.8843 9.40822 15.781 9.88943 15.5923L9.29212 14.0697C8.99812 14.185 8.67729 14.2487 8.33961 14.2487C6.89838 14.2487 5.73003 13.0804 5.73003 11.6392C5.73003 10.1979 6.89838 9.02959 8.33961 9.02959C9.55444 9.02959 10.5773 9.86046 10.867 10.9862L10.8772 10.9836L11.4695 12.7311C11.9515 14.546 13.6048 15.8843 15.5727 15.8843C17.9172 15.8843 19.8178 13.9837 19.8178 11.6392C19.8178 9.29465 17.9172 7.39404 15.5727 7.39404C15.0287 7.39404 14.5066 7.4968 14.0264 7.6847L14.6223 9.20781C14.9158 9.093 15.2358 9.02959 15.5727 9.02959C17.0139 9.02959 18.1823 10.1979 18.1823 11.6392Z"
        })),
            _c = bc,
            Rc = (0, c.createElement)(v.SVG, {
          xmlns: "https://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, c.createElement)(v.Path, {
          d: "M12 9c-.8 0-1.5.7-1.5 1.5S11.2 12 12 12s1.5-.7 1.5-1.5S12.8 9 12 9zm0-5c-3.6 0-6.5 2.8-6.5 6.2 0 .8.3 1.8.9 3.1.5 1.1 1.2 2.3 2 3.6.7 1 3 3.8 3.2 3.9l.4.5.4-.5c.2-.2 2.6-2.9 3.2-3.9.8-1.2 1.5-2.5 2-3.6.6-1.3.9-2.3.9-3.1C18.5 6.8 15.6 4 12 4zm4.3 8.7c-.5 1-1.1 2.2-1.9 3.4-.5.7-1.7 2.2-2.4 3-.7-.8-1.9-2.3-2.4-3-.8-1.2-1.4-2.3-1.9-3.3-.6-1.4-.7-2.2-.7-2.5 0-2.6 2.2-4.7 5-4.7s5 2.1 5 4.7c0 .2-.1 1-.7 2.4z"
        })),
            kc = Rc,
            yc = (0, c.createElement)(v.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, c.createElement)(v.Path, {
          d: "M18.7 3H5.3C4 3 3 4 3 5.3v13.4C3 20 4 21 5.3 21h13.4c1.3 0 2.3-1 2.3-2.3V5.3C21 4 20 3 18.7 3zm.8 15.7c0 .4-.4.8-.8.8H5.3c-.4 0-.8-.4-.8-.8V5.3c0-.4.4-.8.8-.8h13.4c.4 0 .8.4.8.8v13.4zM10 15l5-3-5-3v6z"
        })),
            Zc = yc,
            Ic = (0, c.createElement)(v.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, c.createElement)(v.Path, {
          d: "M3 18h8V6H3v12zM14 7.5V9h7V7.5h-7zm0 5.3h7v-1.5h-7v1.5zm0 3.7h7V15h-7v1.5z"
        })),
            Ac = Ic,
            qc = (0, c.createElement)(v.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, c.createElement)(v.Path, {
          fillRule: "evenodd",
          d: "M6.863 13.644L5 13.25h-.5a.5.5 0 01-.5-.5v-3a.5.5 0 01.5-.5H5L18 6.5h2V16h-2l-3.854-.815.026.008a3.75 3.75 0 01-7.31-1.549zm1.477.313a2.251 2.251 0 004.356.921l-4.356-.921zm-2.84-3.28L18.157 8h.343v6.5h-.343L5.5 11.823v-1.146z",
          clipRule: "evenodd"
        })),
            Oc = qc,
            jc = (0, c.createElement)(v.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, c.createElement)(v.Path, {
          d: "M5 5v1.5h14V5H5zm0 7.8h14v-1.5H5v1.5zM5 19h14v-1.5H5V19z"
        })),
            Tc = jc,
            Dc = (0, c.createElement)(v.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, c.createElement)(v.Path, {
          d: "M15 4H9c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h6c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm.5 14c0 .3-.2.5-.5.5H9c-.3 0-.5-.2-.5-.5V6c0-.3.2-.5.5-.5h6c.3 0 .5.2.5.5v12zm-4.5-.5h2V16h-2v1.5z"
        })),
            Fc = Dc,
            Wc = (0, c.createElement)(v.SVG, {
          viewBox: "0 0 24 24",
          xmlns: "http://www.w3.org/2000/svg"
        }, (0, c.createElement)(v.Path, {
          d: "M4 9v1.5h16V9H4zm12 5.5h4V13h-4v1.5zm-6 0h4V13h-4v1.5zm-6 0h4V13H4v1.5z"
        })),
            Nc = Wc,
            Uc = (0, c.createElement)(v.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, c.createElement)(v.Path, {
          d: "M11 13h2v-2h-2v2zm-6 0h2v-2H5v2zm12-2v2h2v-2h-2z"
        })),
            Jc = Uc,
            Kc = (0, c.createElement)(v.SVG, {
          viewBox: "0 0 24 24",
          xmlns: "http://www.w3.org/2000/svg"
        }, (0, c.createElement)(v.Path, {
          d: "M7.5 12C7.5 11.1716 6.82843 10.5 6 10.5C5.17157 10.5 4.5 11.1716 4.5 12C4.5 12.8284 5.17157 13.5 6 13.5C6.82843 13.5 7.5 12.8284 7.5 12Z"
        }), (0, c.createElement)(v.Path, {
          d: "M13.5 12C13.5 11.1716 12.8284 10.5 12 10.5C11.1716 10.5 10.5 11.1716 10.5 12C10.5 12.8284 11.1716 13.5 12 13.5C12.8284 13.5 13.5 12.8284 13.5 12Z"
        }), (0, c.createElement)(v.Path, {
          d: "M19.5 12C19.5 11.1716 18.8284 10.5 18 10.5C17.1716 10.5 16.5 11.1716 16.5 12C16.5 12.8284 17.1716 13.5 18 13.5C18.8284 13.5 19.5 12.8284 19.5 12Z"
        })),
            Qc = Kc,
            Xc = (0, c.createElement)(v.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, c.createElement)(v.Path, {
          d: "M13 19h-2v-2h2v2zm0-6h-2v-2h2v2zm0-6h-2V5h2v2z"
        })),
            Yc = Xc,
            $c = (0, c.createElement)(v.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, c.createElement)(v.Path, {
          d: "M19.75 9c0-1.257-.565-2.197-1.39-2.858-.797-.64-1.827-1.017-2.815-1.247-1.802-.42-3.703-.403-4.383-.396L11 4.5V6l.177-.001c.696-.006 2.416-.02 4.028.356.887.207 1.67.518 2.216.957.52.416.829.945.829 1.688 0 .592-.167.966-.407 1.23-.255.281-.656.508-1.236.674-1.19.34-2.82.346-4.607.346h-.077c-1.692 0-3.527 0-4.942.404-.732.209-1.424.545-1.935 1.108-.526.579-.796 1.33-.796 2.238 0 1.257.565 2.197 1.39 2.858.797.64 1.827 1.017 2.815 1.247 1.802.42 3.703.403 4.383.396L13 19.5h.714V22L18 18.5 13.714 15v3H13l-.177.001c-.696.006-2.416.02-4.028-.356-.887-.207-1.67-.518-2.216-.957-.52-.416-.829-.945-.829-1.688 0-.592.167-.966.407-1.23.255-.281.656-.508 1.237-.674 1.189-.34 2.819-.346 4.606-.346h.077c1.692 0 3.527 0 4.941-.404.732-.209 1.425-.545 1.936-1.108.526-.579.796-1.33.796-2.238z"
        })),
            eh = $c,
            th = (0, c.createElement)(v.SVG, {
          viewBox: "0 0 24 24",
          xmlns: "http://www.w3.org/2000/svg"
        }, (0, c.createElement)(v.Path, {
          d: "M12 4c-4.4 0-8 3.6-8 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zm0 14.5c-3.6 0-6.5-2.9-6.5-6.5S8.4 5.5 12 5.5s6.5 2.9 6.5 6.5-2.9 6.5-6.5 6.5zM9 16l4.5-3L15 8.4l-4.5 3L9 16z"
        })),
            lh = th,
            ch = (0, c.createElement)(v.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, c.createElement)(v.Path, {
          d: "M18 4H6c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12-9.8c.4 0 .8-.3.9-.7l1.1-3h3.6l.5 1.7h1.9L13 9h-2.2l-3.4 9.5H6c-.3 0-.5-.2-.5-.5V6c0-.3.2-.5.5-.5h12c.3 0 .5.2.5.5v12H20V6c0-1.1-.9-2-2-2zm-6 7l1.4 3.9h-2.7L12 11z"
        })),
            hh = ch,
            vh = (0, c.createElement)(v.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, c.createElement)(v.Path, {
          d: "M7.8 6c0-.7.6-1.2 1.2-1.2h6c.7 0 1.2.6 1.2 1.2v3h1.5V6c0-1.5-1.2-2.8-2.8-2.8H9C7.5 3.2 6.2 4.5 6.2 6v3h1.5V6zm8.4 11c0 .7-.6 1.2-1.2 1.2H9c-.7 0-1.2-.6-1.2-1.2v-3H6.2v3c0 1.5 1.2 2.8 2.8 2.8h6c1.5 0 2.8-1.2 2.8-2.8v-3h-1.5v3zM4 11v1h16v-1H4z"
        })),
            ah = (0, c.createElement)(v.SVG, {
          xmlns: "https://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, c.createElement)(v.Path, {
          d: "M12.5 14.5h-1V16h1c2.2 0 4-1.8 4-4s-1.8-4-4-4h-1v1.5h1c1.4 0 2.5 1.1 2.5 2.5s-1.1 2.5-2.5 2.5zm-4 1.5v-1.5h-1C6.1 14.5 5 13.4 5 12s1.1-2.5 2.5-2.5h1V8h-1c-2.2 0-4 1.8-4 4s1.8 4 4 4h1zm-1-3.2h5v-1.5h-5v1.5zM18 4H9c-1.1 0-2 .9-2 2v.5h1.5V6c0-.3.2-.5.5-.5h9c.3 0 .5.2.5.5v12c0 .3-.2.5-.5.5H9c-.3 0-.5-.2-.5-.5v-.5H7v.5c0 1.1.9 2 2 2h9c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2z"
        })),
            rh = (0, c.createElement)(v.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, c.createElement)(v.Path, {
          d: "M7 5.5h10a.5.5 0 01.5.5v12a.5.5 0 01-.5.5H7a.5.5 0 01-.5-.5V6a.5.5 0 01.5-.5zM17 4H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V6a2 2 0 00-2-2zm-1 3.75H8v1.5h8v-1.5zM8 11h8v1.5H8V11zm6 3.25H8v1.5h6v-1.5z"
        })),
            wh = (0, c.createElement)(v.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, c.createElement)(v.Path, {
          d: "M7 13.8h6v-1.5H7v1.5zM18 16V4c0-1.1-.9-2-2-2H6c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2zM5.5 16V4c0-.3.2-.5.5-.5h10c.3 0 .5.2.5.5v12c0 .3-.2.5-.5.5H6c-.3 0-.5-.2-.5-.5zM7 10.5h8V9H7v1.5zm0-3.3h8V5.8H7v1.4zM20.2 6v13c0 .7-.6 1.2-1.2 1.2H8v1.5h11c1.5 0 2.7-1.2 2.7-2.8V6h-1.5z"
        })),
            nh = (0, c.createElement)(v.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, c.createElement)(v.Path, {
          d: "M18.3 4H9.9v-.1l-.9.2c-2.3.4-4 2.4-4 4.8s1.7 4.4 4 4.8l.7.1V20h1.5V5.5h2.9V20h1.5V5.5h2.7V4z"
        })),
            mh = (0, c.createElement)(v.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, c.createElement)(v.Path, {
          fillRule: "evenodd",
          d: "M5.5 9.5v-2h13v2h-13zm0 3v4h13v-4h-13zM4 7a1 1 0 011-1h14a1 1 0 011 1v10a1 1 0 01-1 1H5a1 1 0 01-1-1V7z",
          clipRule: "evenodd"
        })),
            oh = (0, c.createElement)(v.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, c.createElement)(v.Path, {
          fillRule: "evenodd",
          d: "M6.5 8a1.5 1.5 0 103 0 1.5 1.5 0 00-3 0zM8 5a3 3 0 100 6 3 3 0 000-6zm6.5 11a1.5 1.5 0 103 0 1.5 1.5 0 00-3 0zm1.5-3a3 3 0 100 6 3 3 0 000-6zM5.47 17.41a.75.75 0 001.06 1.06L18.47 6.53a.75.75 0 10-1.06-1.06L5.47 17.41z",
          clipRule: "evenodd"
        })),
            sh = (0, c.createElement)(v.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, c.createElement)(v.Path, {
          d: "M7 9v6h10V9H7zM5 19.8h14v-1.5H5v1.5zM5 4.3v1.5h14V4.3H5z"
        })),
            ih = (0, c.createElement)(v.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, c.createElement)(v.Path, {
          d: "M4 9v6h14V9H4zm8-4.8H4v1.5h8V4.2zM4 19.8h8v-1.5H4v1.5z"
        })),
            Vh = (0, c.createElement)(v.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, c.createElement)(v.Path, {
          d: "M6 15h14V9H6v6zm6-10.8v1.5h8V4.2h-8zm0 15.6h8v-1.5h-8v1.5z"
        })),
            zh = (0, c.createElement)(v.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, c.createElement)(v.Path, {
          d: "M15.5 9.5a1 1 0 100-2 1 1 0 000 2zm0 1.5a2.5 2.5 0 100-5 2.5 2.5 0 000 5zm-2.25 6v-2a2.75 2.75 0 00-2.75-2.75h-4A2.75 2.75 0 003.75 15v2h1.5v-2c0-.69.56-1.25 1.25-1.25h4c.69 0 1.25.56 1.25 1.25v2h1.5zm7-2v2h-1.5v-2c0-.69-.56-1.25-1.25-1.25H15v-1.5h2.5A2.75 2.75 0 0120.25 15zM9.5 8.5a1 1 0 11-2 0 1 1 0 012 0zm1.5 0a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0z",
          fillRule: "evenodd"
        })),
            dh = (0, c.createElement)(v.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "-2 -2 24 24"
        }, (0, c.createElement)(v.Path, {
          d: "M10.44 3.02l1.82-1.82 6.36 6.35-1.83 1.82c-1.05-.68-2.48-.57-3.41.36l-.75.75c-.92.93-1.04 2.35-.35 3.41l-1.83 1.82-2.41-2.41-2.8 2.79c-.42.42-3.38 2.71-3.8 2.29s1.86-3.39 2.28-3.81l2.79-2.79L4.1 9.36l1.83-1.82c1.05.69 2.48.57 3.4-.36l.75-.75c.93-.92 1.05-2.35.36-3.41z"
        })),
            gh = (0, c.createElement)(v.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, c.createElement)(v.Path, {
          d: "M10.5 4v4h3V4H15v4h1.5a1 1 0 011 1v4l-3 4v2a1 1 0 01-1 1h-3a1 1 0 01-1-1v-2l-3-4V9a1 1 0 011-1H9V4h1.5zm.5 12.5v2h2v-2l3-4v-3H8v3l3 4z"
        })),
            Eh = (0, c.createElement)(v.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, c.createElement)(v.Path, {
          d: "M2 12C2 6.44444 6.44444 2 12 2C17.5556 2 22 6.44444 22 12C22 17.5556 17.5556 22 12 22C6.44444 22 2 17.5556 2 12ZM13 11V7H11V11H7V13H11V17H13V13H17V11H13Z"
        })),
            Hh = (0, c.createElement)(v.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "-2 -2 24 24"
        }, (0, c.createElement)(v.Path, {
          d: "M10 1c-5 0-9 4-9 9s4 9 9 9 9-4 9-9-4-9-9-9zm0 16c-3.9 0-7-3.1-7-7s3.1-7 7-7 7 3.1 7 7-3.1 7-7 7zm1-11H9v3H6v2h3v3h2v-3h3V9h-3V6zM10 1c-5 0-9 4-9 9s4 9 9 9 9-4 9-9-4-9-9-9zm0 16c-3.9 0-7-3.1-7-7s3.1-7 7-7 7 3.1 7 7-3.1 7-7 7zm1-11H9v3H6v2h3v3h2v-3h3V9h-3V6z"
        })),
            xh = (0, c.createElement)(v.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, c.createElement)(v.Path, {
          d: "M18 11.2h-5.2V6h-1.6v5.2H6v1.6h5.2V18h1.6v-5.2H18z"
        })),
            ph = (0, c.createElement)(v.SVG, {
          viewBox: "0 0 24 24",
          xmlns: "http://www.w3.org/2000/svg"
        }, (0, c.createElement)(v.Path, {
          d: "M10 4.5a1 1 0 11-2 0 1 1 0 012 0zm1.5 0a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0zm2.25 7.5v-1A2.75 2.75 0 0011 8.25H7A2.75 2.75 0 004.25 11v1h1.5v-1c0-.69.56-1.25 1.25-1.25h4c.69 0 1.25.56 1.25 1.25v1h1.5zM4 20h9v-1.5H4V20zm16-4H4v-1.5h16V16z",
          fillRule: "evenodd",
          clipRule: "evenodd"
        })),
            Mh = (0, c.createElement)(v.SVG, {
          viewBox: "0 0 24 24",
          xmlns: "http://www.w3.org/2000/svg"
        }, (0, c.createElement)(v.Path, {
          d: "M20 4H4v1.5h16V4zm-2 9h-3c-1.1 0-2 .9-2 2v3c0 1.1.9 2 2 2h3c1.1 0 2-.9 2-2v-3c0-1.1-.9-2-2-2zm.5 5c0 .3-.2.5-.5.5h-3c-.3 0-.5-.2-.5-.5v-3c0-.3.2-.5.5-.5h3c.3 0 .5.2.5.5v3zM4 9.5h9V8H4v1.5zM9 13H6c-1.1 0-2 .9-2 2v3c0 1.1.9 2 2 2h3c1.1 0 2-.9 2-2v-3c0-1.1-.9-2-2-2zm.5 5c0 .3-.2.5-.5.5H6c-.3 0-.5-.2-.5-.5v-3c0-.3.2-.5.5-.5h3c.3 0 .5.2.5.5v3z",
          fillRule: "evenodd",
          clipRule: "evenodd"
        })),
            uh = (0, c.createElement)(v.SVG, {
          xmlns: "https://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, c.createElement)(v.Path, {
          d: "M4 20h16v-1.5H4V20zm0-4.8h16v-1.5H4v1.5zm0-6.4v1.5h16V8.8H4zM16 4H4v1.5h12V4z"
        })),
            Bh = (0, c.createElement)(v.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, c.createElement)(v.Path, {
          d: "M14 10.1V4c0-.6-.4-1-1-1H5c-.6 0-1 .4-1 1v8.3c0 .3.2.7.6.8.1.1.2.1.3.1.2 0 .5-.1.6-.3l1.8-1.8H13c.6 0 1-.4 1-1zm-1.5-.5H6.7l-1.2 1.2V4.5h7v5.1zM19 12h-8c-.6 0-1 .4-1 1v6.1c0 .6.4 1 1 1h5.7l1.8 1.8c.1.2.4.3.6.3.1 0 .2 0 .3-.1.4-.1.6-.5.6-.8V13c0-.6-.4-1-1-1zm-.5 7.8l-1.2-1.2h-5.8v-5.1h7v6.3z"
        })),
            Sh = (0, c.createElement)(v.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, c.createElement)(v.Path, {
          d: "M13 8H4v1.5h9V8zM4 4v1.5h16V4H4zm9 8H5c-.6 0-1 .4-1 1v8.3c0 .3.2.7.6.8.1.1.2.1.3.1.2 0 .5-.1.6-.3l1.8-1.8H13c.6 0 1-.4 1-1V13c0-.6-.4-1-1-1zm-2.2 6.6H7l1.6-2.2c.3-.4.5-.7.6-.9.1-.2.2-.4.2-.5 0-.2-.1-.3-.1-.4-.1-.1-.2-.1-.4-.1s-.4 0-.6.1c-.3.1-.5.3-.7.4l-.2.2-.2-1.2.1-.1c.3-.2.5-.3.8-.4.3-.1.6-.1.9-.1.3 0 .6.1.9.2.2.1.4.3.6.5.1.2.2.5.2.7 0 .3-.1.6-.2.9-.1.3-.4.7-.7 1.1l-.5.6h1.6v1.2z"
        })),
            Lh = (0, c.createElement)(v.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, c.createElement)(v.Path, {
          d: "M13 8H4v1.5h9V8zM4 4v1.5h16V4H4zm9 8H5c-.6 0-1 .4-1 1v8.3c0 .3.2.7.6.8.1.1.2.1.3.1.2 0 .5-.1.6-.3l1.8-1.8H13c.6 0 1-.4 1-1V13c0-.6-.4-1-1-1zm-.5 6.6H6.7l-1.2 1.2v-6.3h7v5.1z"
        })),
            Ph = (0, c.createElement)(v.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, c.createElement)(v.Path, {
          d: "M11.696 13.972c.356-.546.599-.958.728-1.235a1.79 1.79 0 00.203-.783c0-.264-.077-.47-.23-.618-.148-.153-.354-.23-.618-.23-.295 0-.569.07-.82.212a3.413 3.413 0 00-.738.571l-.147-1.188c.289-.234.59-.41.903-.526.313-.117.66-.175 1.041-.175.375 0 .695.08.959.24.264.153.46.362.59.626.135.265.203.556.203.876 0 .362-.08.734-.24 1.115-.154.381-.427.87-.82 1.466l-.756 1.152H14v1.106h-4l1.696-2.609z"
        }), (0, c.createElement)(v.Path, {
          d: "M19.5 7h-15v12a.5.5 0 00.5.5h14a.5.5 0 00.5-.5V7zM3 7V5a2 2 0 012-2h14a2 2 0 012 2v14a2 2 0 01-2 2H5a2 2 0 01-2-2V7z"
        })),
            Gh = (0, c.createElement)(v.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, c.createElement)(v.Path, {
          d: "M12.75 9.333c0 .521-.102.977-.327 1.354-.23.386-.555.628-.893.774-.545.234-1.183.227-1.544.222l-.12-.001v-1.5h.123c.414.001.715.002.948-.099a.395.395 0 00.199-.166c.05-.083.114-.253.114-.584V7.2H8.8V4h3.95v5.333zM7.95 9.333c0 .521-.102.977-.327 1.354-.23.386-.555.628-.893.774-.545.234-1.183.227-1.544.222l-.12-.001v-1.5h.123c.414.001.715.002.948-.099a.394.394 0 00.198-.166c.05-.083.115-.253.115-.584V7.2H4V4h3.95v5.333zM13 20H4v-1.5h9V20zM20 16H4v-1.5h16V16z"
        })),
            Ch = (0, c.createElement)(v.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, c.createElement)(v.Path, {
          d: "M19 3H5c-.6 0-1 .4-1 1v7c0 .5.4 1 1 1h14c.5 0 1-.4 1-1V4c0-.6-.4-1-1-1zM5.5 10.5v-.4l1.8-1.3 1.3.8c.3.2.7.2.9-.1L11 8.1l2.4 2.4H5.5zm13 0h-2.9l-4-4c-.3-.3-.8-.3-1.1 0L8.9 8l-1.2-.8c-.3-.2-.6-.2-.9 0l-1.3 1V4.5h13v6zM4 20h9v-1.5H4V20zm0-4h16v-1.5H4V16z"
        })),
            fh = (0, c.createElement)(v.SVG, {
          viewBox: "0 0 24 24",
          xmlns: "http://www.w3.org/2000/svg"
        }, (0, c.createElement)(v.Path, {
          d: "M18 4H6c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm.5 14c0 .3-.2.5-.5.5H6c-.3 0-.5-.2-.5-.5V6c0-.3.2-.5.5-.5h12c.3 0 .5.2.5.5v12zM7 11h2V9H7v2zm0 4h2v-2H7v2zm3-4h7V9h-7v2zm0 4h7v-2h-7v2z"
        })),
            bh = (0, c.createElement)(v.SVG, {
          viewBox: "0 0 24 24",
          xmlns: "http://www.w3.org/2000/svg"
        }, (0, c.createElement)(v.Path, {
          d: "M4 14.5h16V16H4zM4 18.5h9V20H4zM4 4h3c2 0 3 .86 3 2.583 0 .891-.253 1.554-.76 1.988-.505.435-1.24.652-2.204.652H5.542V12H4V4zm2.855 4c.53 0 .924-.114 1.18-.343.266-.228.398-.579.398-1.051 0-.473-.132-.82-.397-1.04-.265-.229-.67-.343-1.217-.343H5.542V8h1.313z"
        })),
            _h = (0, c.createElement)(v.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, c.createElement)(v.Path, {
          d: "M11.6 7l-1.1-1L5 12l5.5 6 1.1-1L7 12l4.6-5zm6 0l-1.1-1-5.5 6 5.5 6 1.1-1-4.6-5 4.6-5z"
        })),
            Rh = (0, c.createElement)(v.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, c.createElement)(v.Path, {
          d: "M6.6 6L5.4 7l4.5 5-4.5 5 1.1 1 5.5-6-5.4-6zm6 0l-1.1 1 4.5 5-4.5 5 1.1 1 5.5-6-5.5-6z"
        })),
            kh = (0, c.createElement)(v.SVG, {
          viewBox: "0 0 24 24",
          xmlns: "http://www.w3.org/2000/svg"
        }, (0, c.createElement)(v.Path, {
          d: "M18 4H6c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm.5 14c0 .3-.2.5-.5.5H6c-.3 0-.5-.2-.5-.5V6c0-.3.2-.5.5-.5h12c.3 0 .5.2.5.5v12zM7 16.5h6V15H7v1.5zm4-4h6V11h-6v1.5zM9 11H7v1.5h2V11zm6 5.5h2V15h-2v1.5z"
        })),
            yh = (0, c.createElement)(v.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, c.createElement)(v.Path, {
          d: "M4 18h6V6H4v12zm9-9.5V10h7V8.5h-7zm0 7h7V14h-7v1.5z"
        })),
            Zh = (0, c.createElement)(v.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, c.createElement)(v.Path, {
          d: "M14 6v12h6V6h-6zM4 10h7V8.5H4V10zm0 5.5h7V14H4v1.5z"
        })),
            Ih = (0, c.createElement)(v.SVG, {
          viewBox: "0 0 24 24",
          xmlns: "http://www.w3.org/2000/svg"
        }, (0, c.createElement)(v.Path, {
          d: "M18 8H6c-1.1 0-2 .9-2 2v4c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2v-4c0-1.1-.9-2-2-2zm.5 6c0 .3-.2.5-.5.5H6c-.3 0-.5-.2-.5-.5v-4c0-.3.2-.5.5-.5h12c.3 0 .5.2.5.5v4zM4 4v1.5h16V4H4zm0 16h16v-1.5H4V20z"
        })),
            Ah = (0, c.createElement)(v.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, c.createElement)(v.Rect, {
          x: "4",
          y: "10.5",
          width: "6",
          height: "3",
          rx: "1.5",
          fill: "#000"
        }), (0, c.createElement)(v.Rect, {
          x: "12",
          y: "10.5",
          width: "3",
          height: "3",
          rx: "1.5",
          fill: "#000"
        }), (0, c.createElement)(v.Rect, {
          x: "17",
          y: "10.5",
          width: "3",
          height: "3",
          rx: "1.5",
          fill: "#000"
        })),
            qh = (0, c.createElement)(v.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, c.createElement)(v.Rect, {
          x: "6",
          y: "10.5",
          width: "3",
          height: "3",
          rx: "1.5",
          fill: "#000"
        }), (0, c.createElement)(v.Rect, {
          x: "11",
          y: "10.5",
          width: "3",
          height: "3",
          rx: "1.5",
          fill: "#000"
        }), (0, c.createElement)(v.Path, {
          d: "M16.5 9.5L19 12l-2.5 2.5",
          stroke: "#1E1E1E",
          strokeWidth: "1.5"
        })),
            Oh = (0, c.createElement)(v.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, c.createElement)(v.Rect, {
          x: "4",
          y: "10.5",
          width: "6",
          height: "3",
          rx: "1.5",
          fill: "#000"
        }), (0, c.createElement)(v.Path, {
          d: "M13.5 14v-4l-1.5.5",
          stroke: "#1E1E1E"
        }), (0, c.createElement)(v.Path, {
          d: "M19.266 9.805c-.473-.611-1.22-.51-1.702-.367a3.854 3.854 0 00-.718.307l.13 1.082c.192-.17.47-.422.782-.515.34-.1.578.025.668.141.21.27-.034.835-.16 1.055-.49.85-.93 1.594-1.45 2.492H19.5v-1h-.914c.277-.574.814-1.443.914-2.106.052-.343.02-.762-.234-1.09z",
          fill: "#1E1E1E"
        })),
            jh = (0, c.createElement)(v.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, c.createElement)(v.Rect, {
          x: "18",
          y: "13.5",
          width: "3",
          height: "3",
          rx: "1.5",
          transform: "rotate(-180 18 13.5)",
          fill: "#000"
        }), (0, c.createElement)(v.Rect, {
          x: "13",
          y: "13.5",
          width: "3",
          height: "3",
          rx: "1.5",
          transform: "rotate(-180 13 13.5)",
          fill: "#000"
        }), (0, c.createElement)(v.Path, {
          d: "M7.5 14.5L5 12l2.5-2.5",
          stroke: "#1E1E1E",
          strokeWidth: "1.5"
        })),
            Th = (0, c.createElement)(v.SVG, {
          viewBox: "0 0 24 24",
          xmlns: "http://www.w3.org/2000/svg"
        }, (0, c.createElement)(v.Path, {
          d: "M13 6v6h5.2v4c0 .8-.2 1.4-.5 1.7-.6.6-1.6.6-2.5.5h-.3v1.5h.5c1 0 2.3-.1 3.3-1 .6-.6 1-1.6 1-2.8V6H13zm-9 6h5.2v4c0 .8-.2 1.4-.5 1.7-.6.6-1.6.6-2.5.5h-.3v1.5h.5c1 0 2.3-.1 3.3-1 .6-.6 1-1.6 1-2.8V6H4v6z"
        })),
            Dh = (0, c.createElement)(v.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, c.createElement)(v.Path, {
          fillRule: "evenodd",
          d: "M16.83 6.342l.602.3.625-.25.443-.176v12.569l-.443-.178-.625-.25-.603.301-1.444.723-2.41-.804-.475-.158-.474.158-2.41.803-1.445-.722-.603-.3-.625.25-.443.177V6.215l.443.178.625.25.603-.301 1.444-.722 2.41.803.475.158.474-.158 2.41-.803 1.445.722zM20 4l-1.5.6-1 .4-2-1-3 1-3-1-2 1-1-.4L5 4v17l1.5-.6 1-.4 2 1 3-1 3 1 2-1 1 .4 1.5.6V4zm-3.5 6.25v-1.5h-8v1.5h8zm0 3v-1.5h-8v1.5h8zm-8 3v-1.5h8v1.5h-8z",
          clipRule: "evenodd"
        })),
            Fh = (0, c.createElement)(v.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, c.createElement)(v.Path, {
          d: "M15.6 6.5l-1.1 1 2.9 3.3H8c-.9 0-1.7.3-2.3.9-1.4 1.5-1.4 4.2-1.4 5.6v.2h1.5v-.3c0-1.1 0-3.5 1-4.5.3-.3.7-.5 1.3-.5h9.2L14.5 15l1.1 1.1 4.6-4.6-4.6-5z"
        })),
            Wh = (0, c.createElement)(v.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, c.createElement)(v.Path, {
          d: "M8.45474 21.2069L16.4547 3.7069L15.5453 3.29114L14.2837 6.05081C13.5991 5.69873 12.8228 5.49999 12 5.49999C10.9385 5.49999 9.95431 5.83076 9.1448 6.39485L7.18994 4.44L6.12928 5.50066L8.05556 7.42694C7.49044 8.15127 7.12047 9.0353 7.02469 9.99999H5V11.5H7V13H5V14.5H7.10002C7.35089 15.7359 8.0576 16.8062 9.03703 17.5279L7.54526 20.7911L8.45474 21.2069ZM9.68024 16.1209C8.95633 15.4796 8.5 14.5431 8.5 13.5V10.5C8.5 8.567 10.067 6.99999 12 6.99999C12.6003 6.99999 13.1653 7.15111 13.659 7.41738L9.68024 16.1209ZM15.3555 9.50155L16.1645 7.73191C16.6053 8.39383 16.8926 9.16683 16.9753 9.99999H19V11.5H17V13H19V14.5H16.9C16.4367 16.7822 14.419 18.5 12 18.5C11.7508 18.5 11.5058 18.4818 11.2664 18.4466L11.928 16.9993C11.9519 16.9998 11.9759 17 12 17C13.933 17 15.5 15.433 15.5 13.5V10.5C15.5 10.1531 15.4495 9.81794 15.3555 9.50155Z"
        })),
            Nh = (0, c.createElement)(v.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, c.createElement)(v.Path, {
          d: "M16 10h4c.6 0 1-.4 1-1V5c0-.6-.4-1-1-1h-4c-.6 0-1 .4-1 1v4c0 .6.4 1 1 1zm-8 4H4c-.6 0-1 .4-1 1v4c0 .6.4 1 1 1h4c.6 0 1-.4 1-1v-4c0-.6-.4-1-1-1zm10-2.6L14.5 15l1.1 1.1 1.7-1.7c-.1 1.1-.3 2.3-.9 2.9-.3.3-.7.5-1.3.5h-4.5v1.5H15c.9 0 1.7-.3 2.3-.9 1-1 1.3-2.7 1.4-4l1.8 1.8 1.1-1.1-3.6-3.7zM6.8 9.7c.1-1.1.3-2.3.9-2.9.4-.4.8-.6 1.3-.6h4.5V4.8H9c-.9 0-1.7.3-2.3.9-1 1-1.3 2.7-1.4 4L3.5 8l-1 1L6 12.6 9.5 9l-1-1-1.7 1.7z"
        })),
            Uh = (0, c.createElement)(v.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, c.createElement)(v.Path, {
          d: "M7 11.5h10V13H7z"
        })),
            Jh = (0, c.createElement)(v.SVG, {
          viewBox: "0 0 24 24",
          xmlns: "http://www.w3.org/2000/svg"
        }, (0, c.createElement)(v.Path, {
          d: "M12.5 4.2v1.6h4.7L5.8 17.2V12H4.2v7.8H12v-1.6H6.8L18.2 6.8v4.7h1.6V4.2z"
        })),
            Kh = (0, c.createElement)(v.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, c.createElement)(v.Path, {
          d: "M7 7.2h8.2L13.5 9l1.1 1.1 3.6-3.6-3.5-4-1.1 1 1.9 2.3H7c-.9 0-1.7.3-2.3.9-1.4 1.5-1.4 4.2-1.4 5.6v.2h1.5v-.3c0-1.1 0-3.5 1-4.5.3-.3.7-.5 1.2-.5zm13.8 4V11h-1.5v.3c0 1.1 0 3.5-1 4.5-.3.3-.7.5-1.3.5H8.8l1.7-1.7-1.1-1.1L5.9 17l3.5 4 1.1-1-1.9-2.3H17c.9 0 1.7-.3 2.3-.9 1.5-1.4 1.5-4.2 1.5-5.6z"
        })),
            Qh = (0, c.createElement)(v.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, c.createElement)(v.Path, {
          d: "M21.3 10.8l-5.6-5.6c-.7-.7-1.8-.7-2.5 0l-5.6 5.6c-.7.7-.7 1.8 0 2.5l5.6 5.6c.3.3.8.5 1.2.5s.9-.2 1.2-.5l5.6-5.6c.8-.7.8-1.9.1-2.5zm-1 1.4l-5.6 5.6c-.1.1-.3.1-.4 0l-5.6-5.6c-.1-.1-.1-.3 0-.4l5.6-5.6s.1-.1.2-.1.1 0 .2.1l5.6 5.6c.1.1.1.3 0 .4zm-16.6-.4L10 5.5l-1-1-6.3 6.3c-.7.7-.7 1.8 0 2.5L9 19.5l1.1-1.1-6.3-6.3c-.2 0-.2-.2-.1-.3z"
        })),
            Xh = (0, c.createElement)(v.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, c.createElement)(v.Path, {
          d: "M12 4V2.2L9 4.8l3 2.5V5.5c3.6 0 6.5 2.9 6.5 6.5 0 2.9-1.9 5.3-4.5 6.2v.2l-.1-.2c-.4.1-.7.2-1.1.2l.2 1.5c.3 0 .6-.1 1-.2 3.5-.9 6-4 6-7.7 0-4.4-3.6-8-8-8zm-7.9 7l1.5.2c.1-1.2.5-2.3 1.2-3.2l-1.1-.9C4.8 8.2 4.3 9.6 4.1 11zm1.5 1.8l-1.5.2c.1.7.3 1.4.5 2 .3.7.6 1.3 1 1.8l1.2-.8c-.3-.5-.6-1-.8-1.5s-.4-1.1-.4-1.7zm1.5 5.5c1.1.9 2.4 1.4 3.8 1.6l.2-1.5c-1.1-.1-2.2-.5-3.1-1.2l-.9 1.1z"
        })),
            Yh = (0, c.createElement)(v.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, c.createElement)(v.Path, {
          d: "M15.1 4.8l-3-2.5V4c-4.4 0-8 3.6-8 8 0 3.7 2.5 6.9 6 7.7.3.1.6.1 1 .2l.2-1.5c-.4 0-.7-.1-1.1-.2l-.1.2v-.2c-2.6-.8-4.5-3.3-4.5-6.2 0-3.6 2.9-6.5 6.5-6.5v1.8l3-2.5zM20 11c-.2-1.4-.7-2.7-1.6-3.8l-1.2.8c.7.9 1.1 2 1.3 3.1L20 11zm-1.5 1.8c-.1.5-.2 1.1-.4 1.6s-.5 1-.8 1.5l1.2.9c.4-.5.8-1.1 1-1.8s.5-1.3.5-2l-1.5-.2zm-5.6 5.6l.2 1.5c1.4-.2 2.7-.7 3.8-1.6l-.9-1.1c-.9.7-2 1.1-3.1 1.2z"
        })),
            $h = (0, c.createElement)(v.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, c.createElement)(v.Path, {
          d: "M5 10.2h-.8v1.5H5c1.9 0 3.8.8 5.1 2.1 1.4 1.4 2.1 3.2 2.1 5.1v.8h1.5V19c0-2.3-.9-4.5-2.6-6.2-1.6-1.6-3.8-2.6-6.1-2.6zm10.4-1.6C12.6 5.8 8.9 4.2 5 4.2h-.8v1.5H5c3.5 0 6.9 1.4 9.4 3.9s3.9 5.8 3.9 9.4v.8h1.5V19c0-3.9-1.6-7.6-4.4-10.4zM4 20h3v-3H4v3z"
        })),
            ev = (0, c.createElement)(v.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, c.createElement)(v.Path, {
          d: "M13.5 6C10.5 6 8 8.5 8 11.5c0 1.1.3 2.1.9 3l-3.4 3 1 1.1 3.4-2.9c1 .9 2.2 1.4 3.6 1.4 3 0 5.5-2.5 5.5-5.5C19 8.5 16.5 6 13.5 6zm0 9.5c-2.2 0-4-1.8-4-4s1.8-4 4-4 4 1.8 4 4-1.8 4-4 4z"
        })),
            tv = (0, c.createElement)(v.SVG, {
          viewBox: "0 0 24 24",
          xmlns: "http://www.w3.org/2000/svg"
        }, (0, c.createElement)(v.Path, {
          d: "M20.2 7v4H3.8V7H2.2v9h1.6v-3.5h16.4V16h1.6V7z"
        })),
            lv = (0, c.createElement)(v.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, c.createElement)(v.Path, {
          d: "M14.5 13.8c-1.1 0-2.1.7-2.4 1.8H4V17h8.1c.3 1 1.3 1.8 2.4 1.8s2.1-.7 2.4-1.8H20v-1.5h-3.1c-.3-1-1.3-1.7-2.4-1.7zM11.9 7c-.3-1-1.3-1.8-2.4-1.8S7.4 6 7.1 7H4v1.5h3.1c.3 1 1.3 1.8 2.4 1.8s2.1-.7 2.4-1.8H20V7h-8.1z"
        })),
            cv = (0, c.createElement)(v.SVG, {
          viewBox: "0 0 24 24",
          xmlns: "http://www.w3.org/2000/svg"
        }, (0, c.createElement)(v.Path, {
          d: "M9 11.8l6.1-4.5c.1.4.4.7.9.7h2c.6 0 1-.4 1-1V5c0-.6-.4-1-1-1h-2c-.6 0-1 .4-1 1v.4l-6.4 4.8c-.2-.1-.4-.2-.6-.2H6c-.6 0-1 .4-1 1v2c0 .6.4 1 1 1h2c.2 0 .4-.1.6-.2l6.4 4.8v.4c0 .6.4 1 1 1h2c.6 0 1-.4 1-1v-2c0-.6-.4-1-1-1h-2c-.5 0-.8.3-.9.7L9 12.2v-.4z"
        })),
            hv = (0, c.createElement)(v.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, c.createElement)(v.Path, {
          d: "M12 3.176l6.75 3.068v4.574c0 3.9-2.504 7.59-6.035 8.755a2.283 2.283 0 01-1.43 0c-3.53-1.164-6.035-4.856-6.035-8.755V6.244L12 3.176zM6.75 7.21v3.608c0 3.313 2.145 6.388 5.005 7.33.159.053.331.053.49 0 2.86-.942 5.005-4.017 5.005-7.33V7.21L12 4.824 6.75 7.21z",
          fillRule: "evenodd",
          clipRule: "evenodd"
        })),
            vv = (0, c.createElement)(v.SVG, {
          viewBox: "0 0 24 24",
          xmlns: "http://www.w3.org/2000/svg"
        }, (0, c.createElement)(v.Path, {
          d: "M16 4.2v1.5h2.5v12.5H16v1.5h4V4.2h-4zM4.2 19.8h4v-1.5H5.8V5.8h2.5V4.2h-4l-.1 15.6zm5.1-3.1l1.4.6 4-10-1.4-.6-4 10z"
        })),
            av = (0, c.createElement)(v.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, c.createElement)(v.Path, {
          d: "M12 3c-5 0-9 4-9 9s4 9 9 9 9-4 9-9-4-9-9-9zm0 1.5c4.1 0 7.5 3.4 7.5 7.5v.1c-1.4-.8-3.3-1.7-3.4-1.8-.2-.1-.5-.1-.8.1l-2.9 2.1L9 11.3c-.2-.1-.4 0-.6.1l-3.7 2.2c-.1-.5-.2-1-.2-1.5 0-4.2 3.4-7.6 7.5-7.6zm0 15c-3.1 0-5.7-1.9-6.9-4.5l3.7-2.2 3.5 1.2c.2.1.5 0 .7-.1l2.9-2.1c.8.4 2.5 1.2 3.5 1.9-.9 3.3-3.9 5.8-7.4 5.8z"
        })),
            rv = (0, c.createElement)(v.SVG, {
          viewBox: "0 0 24 24",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg"
        }, (0, c.createElement)(v.Path, {
          d: "M10 11c-1.588-.479-4-.91-4-.91s2-.241 4-.454c1.8-.191 3.365-.502 4-3.181C14.635 3.775 15 1 15 1s.365 2.775 1 5.455c.635 2.679 2 2.969 4 3.181 2 .213 4 .455 4 .455s-2.412.43-4 .909c-1.588.479-3 1-4 4.546-.746 2.643-.893 4.948-1 5.454-.107-.506-.167-2.5-1-5.454C13 12 11.588 11.479 10 11zM7.333 3.5C6.803 3.333 6 3.182 6 3.182s.667-.085 1.333-.16c.6-.066 1.122-.175 1.334-1.113C8.878.971 9 0 9 0s.122.971.333 1.91c.212.937.667 1.038 1.334 1.113.666.074 1.333.159 1.333.159s-.804.15-1.333.318c-.53.167-1 .35-1.334 1.59C9.085 6.017 9.036 6.824 9 7c-.036-.177-.056-.875-.333-1.91-.334-1.24-.804-1.423-1.334-1.59zM2.444 18C1.474 17.713 0 17.454 0 17.454s1.222-.145 2.444-.272c1.1-.115 2.057-.302 2.445-1.91C5.277 13.666 5.5 12 5.5 12s.223 1.665.611 3.273c.388 1.607 1.222 1.781 2.445 1.909 1.222.127 2.444.273 2.444.273s-1.474.258-2.444.545c-.971.287-1.834.6-2.445 2.727-.456 1.586-.546 2.97-.611 3.273-.065-.304-.102-1.5-.611-3.273C4.278 18.6 3.415 18.287 2.444 18z",
          fill: "#F0C930"
        })),
            wv = (0, c.createElement)(v.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, c.createElement)(v.Path, {
          d: "M20.2 8v11c0 .7-.6 1.2-1.2 1.2H6v1.5h13c1.5 0 2.7-1.2 2.7-2.8V8zM18 16.4V4.6c0-.9-.7-1.6-1.6-1.6H4.6C3.7 3 3 3.7 3 4.6v11.8c0 .9.7 1.6 1.6 1.6h11.8c.9 0 1.6-.7 1.6-1.6zm-13.5 0V4.6c0-.1.1-.1.1-.1h11.8c.1 0 .1.1.1.1v11.8c0 .1-.1.1-.1.1H4.6l-.1-.1z"
        })),
            nv = (0, c.createElement)(v.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, c.createElement)(v.Path, {
          fillRule: "evenodd",
          d: "M9.706 8.646a.25.25 0 01-.188.137l-4.626.672a.25.25 0 00-.139.427l3.348 3.262a.25.25 0 01.072.222l-.79 4.607a.25.25 0 00.362.264l4.138-2.176a.25.25 0 01.233 0l4.137 2.175a.25.25 0 00.363-.263l-.79-4.607a.25.25 0 01.072-.222l3.347-3.262a.25.25 0 00-.139-.427l-4.626-.672a.25.25 0 01-.188-.137l-2.069-4.192a.25.25 0 00-.448 0L9.706 8.646zM12 7.39l-.948 1.921a1.75 1.75 0 01-1.317.957l-2.12.308 1.534 1.495c.412.402.6.982.503 1.55l-.362 2.11 1.896-.997a1.75 1.75 0 011.629 0l1.895.997-.362-2.11a1.75 1.75 0 01.504-1.55l1.533-1.495-2.12-.308a1.75 1.75 0 01-1.317-.957L12 7.39z",
          clipRule: "evenodd"
        })),
            mv = (0, c.createElement)(v.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, c.createElement)(v.Path, {
          d: "M11.776 4.454a.25.25 0 01.448 0l2.069 4.192a.25.25 0 00.188.137l4.626.672a.25.25 0 01.139.426l-3.348 3.263a.25.25 0 00-.072.222l.79 4.607a.25.25 0 01-.362.263l-4.138-2.175a.25.25 0 00-.232 0l-4.138 2.175a.25.25 0 01-.363-.263l.79-4.607a.25.25 0 00-.071-.222L4.754 9.881a.25.25 0 01.139-.426l4.626-.672a.25.25 0 00.188-.137l2.069-4.192z"
        })),
            ov = (0, c.createElement)(v.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, c.createElement)(v.Path, {
          d: "M9.518 8.783a.25.25 0 00.188-.137l2.069-4.192a.25.25 0 01.448 0l2.07 4.192a.25.25 0 00.187.137l4.626.672a.25.25 0 01.139.427l-3.347 3.262a.25.25 0 00-.072.222l.79 4.607a.25.25 0 01-.363.264l-4.137-2.176a.25.25 0 00-.233 0l-4.138 2.175a.25.25 0 01-.362-.263l.79-4.607a.25.25 0 00-.072-.222L4.753 9.882a.25.25 0 01.14-.427l4.625-.672zM12 14.533c.28 0 .559.067.814.2l1.895.997-.362-2.11a1.75 1.75 0 01.504-1.55l1.533-1.495-2.12-.308a1.75 1.75 0 01-1.317-.957L12 7.39v7.143z"
        })),
            sv = (0, c.createElement)(v.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, c.createElement)(v.Path, {
          fillRule: "evenodd",
          d: "M19.75 11H21V8.667L19.875 4H4.125L3 8.667V11h1.25v8.75h15.5V11zm-1.5 0H5.75v7.25H10V13h4v5.25h4.25V11zm-5.5-5.5h2.067l.486 3.24.028.76H12.75v-4zm-3.567 0h2.067v4H8.669l.028-.76.486-3.24zm7.615 3.1l-.464-3.1h2.36l.806 3.345V9.5h-2.668l-.034-.9zM7.666 5.5h-2.36L4.5 8.845V9.5h2.668l.034-.9.464-3.1z",
          clipRule: "evenodd"
        })),
            iv = (0, c.createElement)(v.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, c.createElement)(v.Path, {
          d: "M5 4v11h14V4H5zm3 15.8h8v-1.5H8v1.5z"
        })),
            Vv = (0, c.createElement)(v.SVG, {
          viewBox: "0 0 24 24",
          xmlns: "http://www.w3.org/2000/svg"
        }, (0, c.createElement)(v.Path, {
          d: "M12 4c-4.4 0-8 3.6-8 8v.1c0 4.1 3.2 7.5 7.2 7.9h.8c4.4 0 8-3.6 8-8s-3.6-8-8-8zm0 15V5c3.9 0 7 3.1 7 7s-3.1 7-7 7z"
        })),
            zv = (0, c.createElement)(v.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, c.createElement)(v.Path, {
          d: "M3 6.75C3 5.784 3.784 5 4.75 5H15V7.313l.05.027 5.056 2.73.394.212v3.468a1.75 1.75 0 01-1.75 1.75h-.012a2.5 2.5 0 11-4.975 0H9.737a2.5 2.5 0 11-4.975 0H3V6.75zM13.5 14V6.5H4.75a.25.25 0 00-.25.25V14h.965a2.493 2.493 0 011.785-.75c.7 0 1.332.287 1.785.75H13.5zm4.535 0h.715a.25.25 0 00.25-.25v-2.573l-4-2.16v4.568a2.487 2.487 0 011.25-.335c.7 0 1.332.287 1.785.75zM6.282 15.5a1.002 1.002 0 00.968 1.25 1 1 0 10-.968-1.25zm9 0a1 1 0 101.937.498 1 1 0 00-1.938-.498z"
        })),
            dv = (0, c.createElement)(v.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, c.createElement)(v.Path, {
          d: "M5 9v6h14V9H5zm11-4.8H8v1.5h8V4.2zM8 19.8h8v-1.5H8v1.5z"
        })),
            gv = (0, c.createElement)(v.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, c.createElement)(v.Path, {
          d: "M16.9 18.3l.8-1.2c.4-.6.7-1.2.9-1.6.2-.4.3-.8.3-1.2 0-.3-.1-.7-.2-1-.1-.3-.4-.5-.6-.7-.3-.2-.6-.3-1-.3s-.8.1-1.1.2c-.3.1-.7.3-1 .6l.2 1.3c.3-.3.5-.5.8-.6s.6-.2.9-.2c.3 0 .5.1.7.2.2.2.2.4.2.7 0 .3-.1.5-.2.8-.1.3-.4.7-.8 1.3L15 19.4h4.3v-1.2h-2.4zM14.1 7.2h-2L9.5 11 6.9 7.2h-2l3.6 5.3L4.7 18h2l2.7-4 2.7 4h2l-3.8-5.5 3.8-5.3z"
        })),
            Ev = (0, c.createElement)(v.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, c.createElement)(v.Path, {
          d: "M16.9 10.3l.8-1.3c.4-.6.7-1.2.9-1.6.2-.4.3-.8.3-1.2 0-.3-.1-.7-.2-1-.2-.2-.4-.4-.7-.6-.3-.2-.6-.3-1-.3s-.8.1-1.1.2c-.3.1-.7.3-1 .6l.1 1.3c.3-.3.5-.5.8-.6s.6-.2.9-.2c.3 0 .5.1.7.2.2.2.2.4.2.7 0 .3-.1.5-.2.8-.1.3-.4.7-.8 1.3l-1.8 2.8h4.3v-1.2h-2.2zm-2.8-3.1h-2L9.5 11 6.9 7.2h-2l3.6 5.3L4.7 18h2l2.7-4 2.7 4h2l-3.8-5.5 3.8-5.3z"
        })),
            Hv = (0, c.createElement)(v.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, c.createElement)(v.Path, {
          d: "M5 17.7c.4.5.8.9 1.2 1.2l1.1-1.4c-.4-.3-.7-.6-1-1L5 17.7zM5 6.3l1.4 1.1c.3-.4.6-.7 1-1L6.3 5c-.5.4-.9.8-1.3 1.3zm.1 7.8l-1.7.5c.2.6.4 1.1.7 1.6l1.5-.8c-.2-.4-.4-.8-.5-1.3zM4.8 12v-.7L3 11.1v1.8l1.7-.2c.1-.2.1-.5.1-.7zm3 7.9c.5.3 1.1.5 1.6.7l.5-1.7c-.5-.1-.9-.3-1.3-.5l-.8 1.5zM19 6.3c-.4-.5-.8-.9-1.2-1.2l-1.1 1.4c.4.3.7.6 1 1L19 6.3zm-.1 3.6l1.7-.5c-.2-.6-.4-1.1-.7-1.6l-1.5.8c.2.4.4.8.5 1.3zM5.6 8.6l-1.5-.8c-.3.5-.5 1-.7 1.6l1.7.5c.1-.5.3-.9.5-1.3zm2.2-4.5l.8 1.5c.4-.2.8-.4 1.3-.5l-.5-1.7c-.6.2-1.1.4-1.6.7zm8.8 13.5l1.1 1.4c.5-.4.9-.8 1.2-1.2l-1.4-1.1c-.2.3-.5.6-.9.9zm1.8-2.2l1.5.8c.3-.5.5-1.1.7-1.6l-1.7-.5c-.1.5-.3.9-.5 1.3zm2.6-4.3l-1.7.2v1.4l1.7.2V12v-.9zM11.1 3l.2 1.7h1.4l.2-1.7h-1.8zm3 2.1c.5.1.9.3 1.3.5l.8-1.5c-.5-.3-1.1-.5-1.6-.7l-.5 1.7zM12 19.2h-.7l-.2 1.8h1.8l-.2-1.7c-.2-.1-.5-.1-.7-.1zm2.1-.3l.5 1.7c.6-.2 1.1-.4 1.6-.7l-.8-1.5c-.4.2-.8.4-1.3.5z"
        })),
            xv = (0, c.createElement)(v.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "-2 -2 24 24"
        }, (0, c.createElement)(v.Path, {
          d: "M14.08 12.864V9.216h3.648V7.424H14.08V3.776h-1.728v3.648H8.64v1.792h3.712v3.648zM0 17.92V0h20.48v17.92H0zM6.4 1.28H1.28v3.84H6.4V1.28zm0 5.12H1.28v3.84H6.4V6.4zm0 5.12H1.28v3.84H6.4v-3.84zM19.2 1.28H7.68v14.08H19.2V1.28z"
        })),
            pv = (0, c.createElement)(v.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "-2 -2 24 24"
        }, (0, c.createElement)(v.Path, {
          d: "M6.4 3.776v3.648H2.752v1.792H6.4v3.648h1.728V9.216h3.712V7.424H8.128V3.776zM0 17.92V0h20.48v17.92H0zM12.8 1.28H1.28v14.08H12.8V1.28zm6.4 0h-5.12v3.84h5.12V1.28zm0 5.12h-5.12v3.84h5.12V6.4zm0 5.12h-5.12v3.84h5.12v-3.84z"
        })),
            Mv = (0, c.createElement)(v.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "-2 -2 24 24"
        }, (0, c.createElement)(v.Path, {
          d: "M6.4 9.98L7.68 8.7v-.256L6.4 7.164V9.98zm6.4-1.532l1.28-1.28V9.92L12.8 8.64v-.192zm7.68 9.472V0H0v17.92h20.48zm-1.28-2.56h-5.12v-1.024l-.256.256-1.024-1.024v1.792H7.68v-1.792l-1.024 1.024-.256-.256v1.024H1.28V1.28H6.4v2.368l.704-.704.576.576V1.216h5.12V3.52l.96-.96.32.32V1.216h5.12V15.36zm-5.76-2.112l-3.136-3.136-3.264 3.264-1.536-1.536 3.264-3.264L5.632 5.44l1.536-1.536 3.136 3.136 3.2-3.2 1.536 1.536-3.2 3.2 3.136 3.136-1.536 1.536z"
        })),
            uv = (0, c.createElement)(v.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "-2 -2 24 24"
        }, (0, c.createElement)(v.Path, {
          d: "M13.824 10.176h-2.88v-2.88H9.536v2.88h-2.88v1.344h2.88v2.88h1.408v-2.88h2.88zM0 17.92V0h20.48v17.92H0zM6.4 1.28H1.28v3.84H6.4V1.28zm6.4 0H7.68v3.84h5.12V1.28zm6.4 0h-5.12v3.84h5.12V1.28zm0 5.056H1.28v9.024H19.2V6.336z"
        })),
            Bv = (0, c.createElement)(v.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "-2 -2 24 24"
        }, (0, c.createElement)(v.Path, {
          d: "M6.656 6.464h2.88v2.88h1.408v-2.88h2.88V5.12h-2.88V2.24H9.536v2.88h-2.88zM0 17.92V0h20.48v17.92H0zm7.68-2.56h5.12v-3.84H7.68v3.84zm-6.4 0H6.4v-3.84H1.28v3.84zM19.2 1.28H1.28v9.024H19.2V1.28zm0 10.24h-5.12v3.84h5.12v-3.84zM6.656 6.464h2.88v2.88h1.408v-2.88h2.88V5.12h-2.88V2.24H9.536v2.88h-2.88zM0 17.92V0h20.48v17.92H0zm7.68-2.56h5.12v-3.84H7.68v3.84zm-6.4 0H6.4v-3.84H1.28v3.84zM19.2 1.28H1.28v9.024H19.2V1.28zm0 10.24h-5.12v3.84h5.12v-3.84z"
        })),
            Sv = (0, c.createElement)(v.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "-2 -2 24 24"
        }, (0, c.createElement)(v.Path, {
          d: "M17.728 11.456L14.592 8.32l3.2-3.2-1.536-1.536-3.2 3.2L9.92 3.648 8.384 5.12l3.2 3.2-3.264 3.264 1.536 1.536 3.264-3.264 3.136 3.136 1.472-1.536zM0 17.92V0h20.48v17.92H0zm19.2-6.4h-.448l-1.28-1.28H19.2V6.4h-1.792l1.28-1.28h.512V1.28H1.28v3.84h6.208l1.28 1.28H1.28v3.84h7.424l-1.28 1.28H1.28v3.84H19.2v-3.84z"
        })),
            Lv = (0, c.createElement)(v.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, c.createElement)(v.Path, {
          d: "M4 6v11.5h16V6H4zm1.5 1.5h6V11h-6V7.5zm0 8.5v-3.5h6V16h-6zm13 0H13v-3.5h5.5V16zM13 11V7.5h5.5V11H13z"
        })),
            Pv = (0, c.createElement)(v.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, c.createElement)(v.Path, {
          d: "M20.1 11.2l-6.7-6.7c-.1-.1-.3-.2-.5-.2H5c-.4-.1-.8.3-.8.7v7.8c0 .2.1.4.2.5l6.7 6.7c.2.2.5.4.7.5s.6.2.9.2c.3 0 .6-.1.9-.2.3-.1.5-.3.8-.5l5.6-5.6c.4-.4.7-1 .7-1.6.1-.6-.2-1.2-.6-1.6zM19 13.4L13.4 19c-.1.1-.2.1-.3.2-.2.1-.4.1-.6 0-.1 0-.2-.1-.3-.2l-6.5-6.5V5.8h6.8l6.5 6.5c.2.2.2.4.2.6 0 .1 0 .3-.2.5zM9 8c-.6 0-1 .4-1 1s.4 1 1 1 1-.4 1-1-.4-1-1-1z"
        })),
            Gv = (0, c.createElement)(v.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, c.createElement)(v.Path, {
          d: "M21.3 10.8l-5.6-5.6c-.7-.7-1.8-.7-2.5 0l-5.6 5.6c-.7.7-.7 1.8 0 2.5l5.6 5.6c.3.3.8.5 1.2.5s.9-.2 1.2-.5l5.6-5.6c.8-.7.8-1.9.1-2.5zm-17.6 1L10 5.5l-1-1-6.3 6.3c-.7.7-.7 1.8 0 2.5L9 19.5l1.1-1.1-6.3-6.3c-.2 0-.2-.2-.1-.3z"
        })),
            Cv = (0, c.createElement)(v.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, c.createElement)(v.Path, {
          stroke: "#1E1E1E",
          strokeWidth: "1.5",
          d: "M9 19.25h6M4 19.25h4M12 15.25h8M4 15.25h7"
        }), (0, c.createElement)(v.Path, {
          d: "M8.994 10.103H6.08L5.417 12H4l2.846-8h1.383l2.845 8H9.657l-.663-1.897zm-.457-1.28l-.994-2.857-1.006 2.857h2z",
          fill: "#1E1E1E"
        })),
            fv = (0, c.createElement)(v.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, c.createElement)(v.Path, {
          fillRule: "evenodd",
          d: "M18 5.5h-8v8h8.5V6a.5.5 0 00-.5-.5zm-9.5 8h-3V6a.5.5 0 01.5-.5h2.5v8zM6 4h12a2 2 0 012 2v12a2 2 0 01-2 2H6a2 2 0 01-2-2V6a2 2 0 012-2z"
        })),
            bv = (0, c.createElement)(v.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, c.createElement)(v.Path, {
          d: "M18.5 10.5H10v8h8a.5.5 0 00.5-.5v-7.5zm-10 0h-3V18a.5.5 0 00.5.5h2.5v-8zM6 4h12a2 2 0 012 2v12a2 2 0 01-2 2H6a2 2 0 01-2-2V6a2 2 0 012-2z"
        })),
            _v = (0, c.createElement)(v.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, c.createElement)(v.Path, {
          d: "M18 5.5H6a.5.5 0 00-.5.5v3h13V6a.5.5 0 00-.5-.5zm.5 5H10v8h8a.5.5 0 00.5-.5v-7.5zM6 4h12a2 2 0 012 2v12a2 2 0 01-2 2H6a2 2 0 01-2-2V6a2 2 0 012-2z"
        })),
            Rv = (0, c.createElement)(v.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, c.createElement)(v.Path, {
          d: "M12.9 6h-2l-4 11h1.9l1.1-3h4.2l1.1 3h1.9L12.9 6zm-2.5 6.5l1.5-4.9 1.7 4.9h-3.2z"
        })),
            kv = (0, c.createElement)(v.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, c.createElement)(v.Path, {
          d: "M17 4H7c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm.5 14c0 .3-.2.5-.5.5H7c-.3 0-.5-.2-.5-.5V6c0-.3.2-.5.5-.5h10c.3 0 .5.2.5.5v12zm-7.5-.5h4V16h-4v1.5z"
        })),
            yv = (0, c.createElement)(v.SVG, {
          xmlns: "https://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, c.createElement)(v.Path, {
          d: "M5 4v3h5.5v12h3V7H19V4H5z"
        })),
            Zv = (0, c.createElement)(v.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, c.createElement)(v.Path, {
          d: "M14.103 7.128l2.26-2.26a4 4 0 00-5.207 4.804L5.828 15a2 2 0 102.828 2.828l5.329-5.328a4 4 0 004.804-5.208l-2.261 2.26-1.912-.512-.513-1.912zm-7.214 9.64a.5.5 0 11.707-.707.5.5 0 01-.707.707z"
        })),
            Iv = (0, c.createElement)(v.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, c.createElement)(v.Path, {
          d: "M20 5h-5.7c0-1.3-1-2.3-2.3-2.3S9.7 3.7 9.7 5H4v2h1.5v.3l1.7 11.1c.1 1 1 1.7 2 1.7h5.7c1 0 1.8-.7 2-1.7l1.7-11.1V7H20V5zm-3.2 2l-1.7 11.1c0 .1-.1.2-.3.2H9.1c-.1 0-.3-.1-.3-.2L7.2 7h9.6z"
        })),
            Av = (0, c.createElement)(v.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, c.createElement)(v.Path, {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M19 5v2H5V5h3V4a2 2 0 012-2h4a2 2 0 012 2v1h3zM6.187 8h11.625l-.695 11.125A2 2 0 0115.121 21H8.879a2 2 0 01-1.996-1.875L6.187 8zM14 5h-4V4h4v1z"
        })),
            qv = (0, c.createElement)(v.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, c.createElement)(v.Path, {
          d: "M4.195 8.245a.75.75 0 011.06-.05l5.004 4.55 4.025-3.521L19 13.939V10.75h1.5v5.75h-5.75V15h3.19l-3.724-3.723-3.975 3.478-5.995-5.45a.75.75 0 01-.051-1.06z"
        })),
            Ov = (0, c.createElement)(v.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, c.createElement)(v.Path, {
          d: "M3.445 16.505a.75.75 0 001.06.05l5.005-4.55 4.024 3.521 4.716-4.715V14h1.5V8.25H14v1.5h3.19l-3.724 3.723L9.49 9.995l-5.995 5.45a.75.75 0 00-.05 1.06z"
        })),
            jv = (0, c.createElement)(v.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, c.createElement)(v.Path, {
          d: "M6.9 7L3 17.8h1.7l1-2.8h4.1l1 2.8h1.7L8.6 7H6.9zm-.7 6.6l1.5-4.3 1.5 4.3h-3zM21.6 17c-.1.1-.2.2-.3.2-.1.1-.2.1-.4.1s-.3-.1-.4-.2c-.1-.1-.1-.3-.1-.6V12c0-.5 0-1-.1-1.4-.1-.4-.3-.7-.5-1-.2-.2-.5-.4-.9-.5-.4 0-.8-.1-1.3-.1s-1 .1-1.4.2c-.4.1-.7.3-1 .4-.2.2-.4.3-.6.5-.1.2-.2.4-.2.7 0 .3.1.5.2.8.2.2.4.3.8.3.3 0 .6-.1.8-.3.2-.2.3-.4.3-.7 0-.3-.1-.5-.2-.7-.2-.2-.4-.3-.6-.4.2-.2.4-.3.7-.4.3-.1.6-.1.8-.1.3 0 .6 0 .8.1.2.1.4.3.5.5.1.2.2.5.2.9v1.1c0 .3-.1.5-.3.6-.2.2-.5.3-.9.4-.3.1-.7.3-1.1.4-.4.1-.8.3-1.1.5-.3.2-.6.4-.8.7-.2.3-.3.7-.3 1.2 0 .6.2 1.1.5 1.4.3.4.9.5 1.6.5.5 0 1-.1 1.4-.3.4-.2.8-.6 1.1-1.1 0 .4.1.7.3 1 .2.3.6.4 1.2.4.4 0 .7-.1.9-.2.2-.1.5-.3.7-.4h-.3zm-3-.9c-.2.4-.5.7-.8.8-.3.2-.6.2-.8.2-.4 0-.6-.1-.9-.3-.2-.2-.3-.6-.3-1.1 0-.5.1-.9.3-1.2s.5-.5.8-.7c.3-.2.7-.3 1-.5.3-.1.6-.3.7-.6v3.4z"
        })),
            Tv = (0, c.createElement)(v.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, c.createElement)(v.Path, {
          d: "M18.3 11.7c-.6-.6-1.4-.9-2.3-.9H6.7l2.9-3.3-1.1-1-4.5 5L8.5 16l1-1-2.7-2.7H16c.5 0 .9.2 1.3.5 1 1 1 3.4 1 4.5v.3h1.5v-.2c0-1.5 0-4.3-1.5-5.7z"
        })),
            Dv = (0, c.createElement)(v.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, c.createElement)(v.Path, {
          d: "M18 4h-7c-1.1 0-2 .9-2 2v7c0 1.1.9 2 2 2h7c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm.5 9c0 .3-.2.5-.5.5h-7c-.3 0-.5-.2-.5-.5V6c0-.3.2-.5.5-.5h7c.3 0 .5.2.5.5v7zm-5 5c0 .3-.2.5-.5.5H6c-.3 0-.5-.2-.5-.5v-7c0-.3.2-.5.5-.5h1V9H6c-1.1 0-2 .9-2 2v7c0 1.1.9 2 2 2h7c1.1 0 2-.9 2-2v-1h-1.5v1z"
        })),
            Fv = (0, c.createElement)(v.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "-2 -2 24 24"
        }, (0, c.createElement)(v.Path, {
          d: "M10.2 3.28c3.53 0 6.43 2.61 6.92 6h2.08l-3.5 4-3.5-4h2.32c-.45-1.97-2.21-3.45-4.32-3.45-1.45 0-2.73.71-3.54 1.78L4.95 5.66C6.23 4.2 8.11 3.28 10.2 3.28zm-.4 13.44c-3.52 0-6.43-2.61-6.92-6H.8l3.5-4c1.17 1.33 2.33 2.67 3.5 4H5.48c.45 1.97 2.21 3.45 4.32 3.45 1.45 0 2.73-.71 3.54-1.78l1.71 1.95c-1.28 1.46-3.15 2.38-5.25 2.38z"
        })),
            Wv = (0, c.createElement)(v.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, c.createElement)(v.Path, {
          d: "M18.5 15v3.5H13V6.7l4.5 4.1 1-1.1-6.2-5.8-5.8 5.8 1 1.1 4-4v11.7h-6V15H4v5h16v-5z"
        })),
            Nv = (0, c.createElement)(v.SVG, {
          viewBox: "0 0 24 24",
          xmlns: "http://www.w3.org/2000/svg"
        }, (0, c.createElement)(v.Path, {
          d: "M17.8 2l-.9.3c-.1 0-3.6 1-5.2 2.1C10 5.5 9.3 6.5 8.9 7.1c-.6.9-1.7 4.7-1.7 6.3l-.9 2.3c-.2.4 0 .8.4 1 .1 0 .2.1.3.1.3 0 .6-.2.7-.5l.6-1.5c.3 0 .7-.1 1.2-.2.7-.1 1.4-.3 2.2-.5.8-.2 1.6-.5 2.4-.8.7-.3 1.4-.7 1.9-1.2s.8-1.2 1-1.9c.2-.7.3-1.6.4-2.4.1-.8.1-1.7.2-2.5 0-.8.1-1.5.2-2.1V2zm-1.9 5.6c-.1.8-.2 1.5-.3 2.1-.2.6-.4 1-.6 1.3-.3.3-.8.6-1.4.9-.7.3-1.4.5-2.2.8-.6.2-1.3.3-1.8.4L15 7.5c.3-.3.6-.7 1-1.1 0 .4 0 .8-.1 1.2zM6 20h8v-1.5H6V20z"
        })),
            Uv = (0, c.createElement)(v.SVG, {
          viewBox: "0 0 24 24",
          xmlns: "http://www.w3.org/2000/svg"
        }, (0, c.createElement)(v.Path, {
          d: "M18.7 3H5.3C4 3 3 4 3 5.3v13.4C3 20 4 21 5.3 21h13.4c1.3 0 2.3-1 2.3-2.3V5.3C21 4 20 3 18.7 3zm.8 15.7c0 .4-.4.8-.8.8H5.3c-.4 0-.8-.4-.8-.8V5.3c0-.4.4-.8.8-.8h13.4c.4 0 .8.4.8.8v13.4zM10 15l5-3-5-3v6z"
        })),
            Jv = (0, c.createElement)(v.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "-2 -2 24 24"
        }, (0, c.createElement)(v.Path, {
          d: "M10 2c4.42 0 8 3.58 8 8s-3.58 8-8 8-8-3.58-8-8 3.58-8 8-8zm1.13 9.38l.35-6.46H8.52l.35 6.46h2.26zm-.09 3.36c.24-.23.37-.55.37-.96 0-.42-.12-.74-.36-.97s-.59-.35-1.06-.35-.82.12-1.07.35-.37.55-.37.97c0 .41.13.73.38.96.26.23.61.34 1.06.34s.8-.11 1.05-.34z"
        })),
            Kv = (0, c.createElement)(v.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, c.createElement)(v.Path, {
          d: "M6 3H8V5H16V3H18V5C19.1046 5 20 5.89543 20 7V19C20 20.1046 19.1046 21 18 21H6C4.89543 21 4 20.1046 4 19V7C4 5.89543 4.89543 5 6 5V3ZM18 6.5H6C5.72386 6.5 5.5 6.72386 5.5 7V8H18.5V7C18.5 6.72386 18.2761 6.5 18 6.5ZM18.5 9.5H5.5V19C5.5 19.2761 5.72386 19.5 6 19.5H18C18.2761 19.5 18.5 19.2761 18.5 19V9.5ZM11 11H13V13H11V11ZM7 11V13H9V11H7ZM15 13V11H17V13H15Z"
        })),
            Qv = (0, c.createElement)(v.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "-2 -2 24 24"
        }, (0, c.createElement)(v.Path, {
          d: "M20 10c0-5.51-4.49-10-10-10C4.48 0 0 4.49 0 10c0 5.52 4.48 10 10 10 5.51 0 10-4.48 10-10zM7.78 15.37L4.37 6.22c.55-.02 1.17-.08 1.17-.08.5-.06.44-1.13-.06-1.11 0 0-1.45.11-2.37.11-.18 0-.37 0-.58-.01C4.12 2.69 6.87 1.11 10 1.11c2.33 0 4.45.87 6.05 2.34-.68-.11-1.65.39-1.65 1.58 0 .74.45 1.36.9 2.1.35.61.55 1.36.55 2.46 0 1.49-1.4 5-1.4 5l-3.03-8.37c.54-.02.82-.17.82-.17.5-.05.44-1.25-.06-1.22 0 0-1.44.12-2.38.12-.87 0-2.33-.12-2.33-.12-.5-.03-.56 1.2-.06 1.22l.92.08 1.26 3.41zM17.41 10c.24-.64.74-1.87.43-4.25.7 1.29 1.05 2.71 1.05 4.25 0 3.29-1.73 6.24-4.4 7.78.97-2.59 1.94-5.2 2.92-7.78zM6.1 18.09C3.12 16.65 1.11 13.53 1.11 10c0-1.3.23-2.48.72-3.59C3.25 10.3 4.67 14.2 6.1 18.09zm4.03-6.63l2.58 6.98c-.86.29-1.76.45-2.71.45-.79 0-1.57-.11-2.29-.33.81-2.38 1.62-4.74 2.42-7.1z"
        }));
      },
      275: function _(e, t, l) {
        "use strict";

        var c = l(424);
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), Object.defineProperty(t, "ReusableBlocksMenuItems", {
          enumerable: !0,
          get: function get() {
            return h.default;
          }
        });
        var h = c(l(579));
      },
      579: function _(e, t, l) {
        "use strict";

        var c = l(424);
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.default = void 0;
        var h = l(753),
            v = l(467),
            a = l(326),
            r = c(l(456)),
            w = c(l(519));
        var n = (0, v.withSelect)(function (e) {
          var _e2 = e(a.store),
              t = _e2.getSelectedBlockClientIds;

          return {
            clientIds: t()
          };
        })(function ReusableBlocksMenuItems(e) {
          var t = e.clientIds,
              l = e.rootClientId;
          return (0, h.createElement)(h.Fragment, null, (0, h.createElement)(r.default, {
            clientIds: t,
            rootClientId: l
          }), 1 === t.length && (0, h.createElement)(w.default, {
            clientId: t[0]
          }));
        });
        t.default = n;
      },
      456: function _(e, t, l) {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.default = function ReusableBlockConvertButton(e) {
          var t = e.clientIds,
              l = e.rootClientId;

          var _ref = (0, c.useState)(!1),
              _ref2 = _slicedToArray(_ref, 2),
              i = _ref2[0],
              V = _ref2[1],
              _ref3 = (0, c.useState)(""),
              _ref4 = _slicedToArray(_ref3, 2),
              z = _ref4[0],
              d = _ref4[1],
              g = (0, w.useSelect)(function (e) {
            var c;

            var _e3 = e(o.store),
                a = _e3.canUser,
                _e4 = e(v.store),
                r = _e4.getBlocksByClientId,
                w = _e4.canInsertBlockType,
                n = null !== (c = r(t)) && void 0 !== c ? c : [];

            return !(1 === n.length && n[0] && (0, h.isReusableBlock)(n[0]) && !!e(o.store).getEntityRecord("postType", "wp_block", n[0].attributes.ref)) && w("core/block", l) && n.every(function (e) {
              return !!e && e.isValid && (0, h.hasBlockSupport)(e.name, "reusable", !0);
            }) && !!a("create", "blocks");
          }, [t]),
              _ref5 = (0, w.useDispatch)(s.store),
              E = _ref5.__experimentalConvertBlocksToReusable,
              _ref6 = (0, w.useDispatch)(m.store),
              H = _ref6.createSuccessNotice,
              x = _ref6.createErrorNotice,
              p = (0, c.useCallback)( /*#__PURE__*/function () {
            var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(e) {
              return _regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                  switch (_context.prev = _context.next) {
                    case 0:
                      _context.prev = 0;
                      _context.next = 3;
                      return E(t, e);

                    case 3:
                      H((0, n.__)("Reusable block created."), {
                        type: "snackbar"
                      });
                      _context.next = 9;
                      break;

                    case 6:
                      _context.prev = 6;
                      _context.t0 = _context["catch"](0);
                      x(_context.t0.message, {
                        type: "snackbar"
                      });

                    case 9:
                    case "end":
                      return _context.stop();
                  }
                }
              }, _callee, null, [[0, 6]]);
            }));

            return function (_x) {
              return _ref7.apply(this, arguments);
            };
          }(), [t]);

          if (!g) return null;
          return (0, c.createElement)(v.BlockSettingsMenuControls, null, function (e) {
            var t = e.onClose;
            return (0, c.createElement)(c.Fragment, null, (0, c.createElement)(a.MenuItem, {
              icon: r.reusableBlock,
              onClick: function onClick() {
                V(!0);
              }
            }, (0, n.__)("Add to Reusable blocks")), i && (0, c.createElement)(a.Modal, {
              title: (0, n.__)("Create Reusable block"),
              closeLabel: (0, n.__)("Close"),
              onRequestClose: function onRequestClose() {
                V(!1), d("");
              },
              overlayClassName: "reusable-blocks-menu-items__convert-modal"
            }, (0, c.createElement)("form", {
              onSubmit: function onSubmit(e) {
                e.preventDefault(), p(z), V(!1), d(""), t();
              }
            }, (0, c.createElement)(a.TextControl, {
              label: (0, n.__)("Name"),
              value: z,
              onChange: d
            }), (0, c.createElement)(a.Flex, {
              className: "reusable-blocks-menu-items__convert-modal-actions",
              justify: "flex-end"
            }, (0, c.createElement)(a.FlexItem, null, (0, c.createElement)(a.Button, {
              variant: "secondary",
              onClick: function onClick() {
                V(!1), d("");
              }
            }, (0, n.__)("Cancel"))), (0, c.createElement)(a.FlexItem, null, (0, c.createElement)(a.Button, {
              variant: "primary",
              type: "submit"
            }, (0, n.__)("Save")))))));
          });
        };
        var c = l(753),
            h = l(700),
            v = l(326),
            a = l(892),
            r = l(614),
            w = l(467),
            n = l(756),
            m = l(448),
            o = l(295),
            s = l(346);
      },
      519: function _(e, t, l) {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.default = void 0;
        var c = l(753),
            h = l(892),
            v = l(756),
            a = l(700),
            r = l(467),
            w = l(326),
            n = l(904),
            m = l(295),
            o = l(346);

        var s = function ReusableBlocksManageButton(e) {
          var t = e.clientId;

          var _ref8 = (0, r.useSelect)(function (e) {
            var _e5 = e(w.store),
                l = _e5.getBlock,
                _e6 = e(m.store),
                c = _e6.canUser,
                h = l(t);

            return {
              isVisible: !!h && (0, a.isReusableBlock)(h) && !!c("update", "blocks", h.attributes.ref)
            };
          }, [t]),
              l = _ref8.isVisible,
              _ref9 = (0, r.useDispatch)(o.store),
              s = _ref9.__experimentalConvertBlockToStatic;

          return l ? (0, c.createElement)(w.BlockSettingsMenuControls, null, (0, c.createElement)(h.MenuItem, {
            href: (0, n.addQueryArgs)("edit.php", {
              post_type: "wp_block"
            })
          }, (0, v.__)("Manage Reusable blocks")), (0, c.createElement)(h.MenuItem, {
            onClick: function onClick() {
              return s(t);
            }
          }, (0, v.__)("Convert to regular blocks"))) : null;
        };

        t.default = s;
      },
      114: function _(e, t, l) {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        var c = {
          store: !0
        };
        Object.defineProperty(t, "store", {
          enumerable: !0,
          get: function get() {
            return h.store;
          }
        });
        var h = l(346),
            v = l(275);
        Object.keys(v).forEach(function (e) {
          "default" !== e && "__esModule" !== e && (Object.prototype.hasOwnProperty.call(c, e) || e in t && t[e] === v[e] || Object.defineProperty(t, e, {
            enumerable: !0,
            get: function get() {
              return v[e];
            }
          }));
        });
      },
      417: function _(e, t, l) {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.__experimentalDeleteReusableBlock = t.__experimentalConvertBlocksToReusable = t.__experimentalConvertBlockToStatic = void 0, t.__experimentalSetEditingReusableBlock = function __experimentalSetEditingReusableBlock(e, t) {
          return {
            type: "SET_EDITING_REUSABLE_BLOCK",
            clientId: e,
            isEditing: t
          };
        };
        var c = l(793),
            h = l(326),
            v = l(700),
            a = l(756);

        t.__experimentalConvertBlockToStatic = function (e) {
          return function (t) {
            var l = t.registry;
            var a = l.select(h.store).getBlock(e),
                r = l.select("core").getEditedEntityRecord("postType", "wp_block", a.attributes.ref),
                w = (0, v.parse)((0, c.isFunction)(r.content) ? r.content(r) : r.content);
            l.dispatch(h.store).replaceBlocks(a.clientId, w);
          };
        };

        t.__experimentalConvertBlocksToReusable = function (e, t) {
          return /*#__PURE__*/function () {
            var _ref10 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(l) {
              var c, r, w, n, m;
              return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                while (1) {
                  switch (_context2.prev = _context2.next) {
                    case 0:
                      c = l.registry, r = l.dispatch;
                      w = {
                        title: t || (0, a.__)("Untitled Reusable block"),
                        content: (0, v.serialize)(c.select(h.store).getBlocksByClientId(e)),
                        status: "publish"
                      };
                      _context2.next = 4;
                      return c.dispatch("core").saveEntityRecord("postType", "wp_block", w);

                    case 4:
                      n = _context2.sent;
                      m = (0, v.createBlock)("core/block", {
                        ref: n.id
                      });
                      c.dispatch(h.store).replaceBlocks(e, m), r.__experimentalSetEditingReusableBlock(m.clientId, !0);

                    case 7:
                    case "end":
                      return _context2.stop();
                  }
                }
              }, _callee2);
            }));

            return function (_x2) {
              return _ref10.apply(this, arguments);
            };
          }();
        };

        t.__experimentalDeleteReusableBlock = function (e) {
          return /*#__PURE__*/function () {
            var _ref11 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(t) {
              var l, c;
              return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                while (1) {
                  switch (_context3.prev = _context3.next) {
                    case 0:
                      l = t.registry;

                      if (l.select("core").getEditedEntityRecord("postType", "wp_block", e)) {
                        _context3.next = 3;
                        break;
                      }

                      return _context3.abrupt("return");

                    case 3:
                      c = l.select(h.store).getBlocks().filter(function (t) {
                        return (0, v.isReusableBlock)(t) && t.attributes.ref === e;
                      }).map(function (e) {
                        return e.clientId;
                      });
                      c.length && l.dispatch(h.store).removeBlocks(c);
                      _context3.next = 7;
                      return l.dispatch("core").deleteEntityRecord("postType", "wp_block", e);

                    case 7:
                    case "end":
                      return _context3.stop();
                  }
                }
              }, _callee3);
            }));

            return function (_x3) {
              return _ref11.apply(this, arguments);
            };
          }();
        };
      },
      346: function _(e, t, l) {
        "use strict";

        var c = l(424);
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.store = void 0;

        var h = l(467),
            v = _interopRequireWildcard(l(417)),
            a = c(l(645)),
            r = _interopRequireWildcard(l(599));

        function _getRequireWildcardCache(e) {
          if ("function" != typeof WeakMap) return null;
          var t = new WeakMap(),
              l = new WeakMap();
          return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
            return e ? l : t;
          })(e);
        }

        function _interopRequireWildcard(e, t) {
          if (!t && e && e.__esModule) return e;
          if (null === e || "object" != typeof e && "function" != typeof e) return {
            default: e
          };

          var l = _getRequireWildcardCache(t);

          if (l && l.has(e)) return l.get(e);
          var c = {},
              h = Object.defineProperty && Object.getOwnPropertyDescriptor;

          for (var v in e) {
            if ("default" !== v && Object.prototype.hasOwnProperty.call(e, v)) {
              var a = h ? Object.getOwnPropertyDescriptor(e, v) : null;
              a && (a.get || a.set) ? Object.defineProperty(c, v, a) : c[v] = e[v];
            }
          }

          return c.default = e, l && l.set(e, c), c;
        }

        var w = (0, h.createReduxStore)("core/reusable-blocks", {
          actions: v,
          reducer: a.default,
          selectors: r,
          __experimentalUseThunks: !0
        });
        t.store = w, (0, h.register)(w);
      },
      645: function _(e, t, l) {
        "use strict";

        function isEditingReusableBlock() {
          var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
              t = arguments.length > 1 ? arguments[1] : void 0;
          return "SET_EDITING_REUSABLE_BLOCK" === (null == t ? void 0 : t.type) ? _objectSpread(_objectSpread({}, e), {}, _defineProperty({}, t.clientId, t.isEditing)) : e;
        }

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.default = void 0, t.isEditingReusableBlock = isEditingReusableBlock;
        var c = (0, l(467).combineReducers)({
          isEditingReusableBlock: isEditingReusableBlock
        });
        t.default = c;
      },
      599: function _(e, t) {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.__experimentalIsEditingReusableBlock = function __experimentalIsEditingReusableBlock(e, t) {
          return e.isEditingReusableBlock[t];
        };
      },
      326: function _(e) {
        "use strict";

        e.exports = require("@wordpress/block-editor");
      },
      700: function _(e) {
        "use strict";

        e.exports = require("@wordpress/blocks");
      },
      892: function _(e) {
        "use strict";

        e.exports = require("@wordpress/components");
      },
      295: function _(e) {
        "use strict";

        e.exports = require("@wordpress/core-data");
      },
      467: function _(e) {
        "use strict";

        e.exports = require("@wordpress/data");
      },
      753: function _(e) {
        "use strict";

        e.exports = require("@wordpress/element");
      },
      756: function _(e) {
        "use strict";

        e.exports = require("@wordpress/i18n");
      },
      448: function _(e) {
        "use strict";

        e.exports = require("@wordpress/notices");
      },
      904: function _(e) {
        "use strict";

        e.exports = require("@wordpress/url");
      },
      793: function _(e) {
        "use strict";

        e.exports = require("lodash");
      }
    },
        t = {};

    function __webpack_require__(l) {
      var c = t[l];
      if (void 0 !== c) return c.exports;
      var h = t[l] = {
        exports: {}
      };
      return e[l](h, h.exports, __webpack_require__), h.exports;
    }

    return __webpack_require__.d = function (e, t) {
      for (var l in t) {
        __webpack_require__.o(t, l) && !__webpack_require__.o(e, l) && Object.defineProperty(e, l, {
          enumerable: !0,
          get: t[l]
        });
      }
    }, __webpack_require__.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, __webpack_require__.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, __webpack_require__(114);
  }();
});